{
    "brand": "Fireknife",
    "welcome": "Welcome to the i18n demo!",
    "errors": {
        "invalidCredentials": "Invalid credentials",
        "unauthorizedToAdd": "Unauthorized to add",
        "unauthorizedToDelete": "Unauthorized to delete",
        "unauthorizedToResetTwoFactor": "Unauthorized to reset two-factor authentication",
        "unauthorizedToEdit": "Unauthorized to edit",
        "unauthorizedToGet": "Unauthorized to get",
        "unauthorizedToToggle": "Unauthorized to toggle",
        "unauthorizedToImport": "Unauthorized to import from FareHarbor",
        "doesNotExist": "does not exist",
        "notFound": "Not found",
        "areRequired": "required",
        "areRequiredParams": "Missing required parameters",
        "alreadyExists": "Already exists",
        "alreadyExistsAtTheSameVenue": "Already exists at the same venue",
        "alreadyExistsForTheSameShow": "Already exists for the same show",
        "commissionGroupAlreadyAssigned": "User is already assigned to another commission group for this show",
        "affiliateCodeGeneration": "Could not generate a unique affiliate code",
        "checkinClosed": "Check-in is closed for this timeslot",
        "email": "Invalid email format",
        "notAllowedToAdd": "You are not allowed to add",
        "notAllowedToDelete": "You are not allowed to delete",
        "notAllowedToEdit": "You are not allowed to edit",
        "notAllowedToGet": "You are not allowed to get",
        "seatsDoNotBelong": "Some of the seats do not belong to this show!",
        "invalidPaymentType": "Invalid payment type",
        "invalidRole": "Invalid role",
        "emailAlreadyExists": "Email already exists in this venue!",
        "unauthorizedToDelegate": "You are not authorized to delegate these capabilities",
        "cannotRemoveOwnUsersManage": "You cannot remove your own user management capability",
        "userIsNotConnectedToThisVenue": "This user is not connected to this venue",
        "notAllowedToSwitchVenues": "You are not allowed to switch to this venue",
        "noAuthHeader": "No authorization header provided!",
        "sessionExpired": "Session expired, please log in again!",
        "invalidJWT": "Invalid JWT token",
        "invalidBearerFormat": "Authorization header should be in Bearer format",
        "unauthorized": "Unauthorized",
        "alreadyInTheDesiredState": "Already in the desired state",
        "unauthorizedToTriggerThisAction": "You are not authorized to trigger this action",
        "orderNotPending": "Order is not in pending state",
        "unauthorizedToCancelReservation": "You are not authorized to cancel this reservation",
        "unauthorizedToRefundReservation": "You are not authorized to refund this reservation",
        "rollbackTimeNotSet": "Rollback time is not set for this show",
        "invalidDate": "Invalid date — must be a valid future date",
        "rollbackTimeMustBeLater": "New rollback time must be later than the current one",
        "noTicketsInCart": "At least one ticket is required",
        "tripadvisorDataNotFound": "Tripadvisor data not found for this show at the provided URL",
        "tripadvisorUrlInvalid": "Tripadvisor URL is invalid",
        "tripadvisorDataFetchError": "Error fetching Tripadvisor data for this show",
        "unauthorizedToModifyTickets": "You are not authorized to modify tickets",
        "cannotModifyTicketsPendingOrder": "Cannot modify tickets for a pending order",
        "cannotModifyTickets": "Cannot modify tickets",
        "duplicateTicketSeats": "Seats in a booking should be unique. Duplicate seats found.",
        "missingTicketSeat": "A seat is missing for a ticket that requires one.",
        "invalidTicketSeat": "Invalid ticket seats provided. Please check the seats!",
        "seatAlreadyUsedInAnotherBooking": "This seat is already used in another booking. Seat: {{seatIds}}",
        "duplicateSeatsInBatch": "Duplicate seat assignments in the request",
        "seatNotCompatibleWithTicketType": "Seat {{seatId}} is not compatible with the ticket type",
        "ticketTypeMismatch": "Seat does not match the assigned ticket type",
        "bookingItemsMismatch": "Booking items do not match the booking. Please reload the booking!",
        "fareharborImportError": "An error occurred while importing data from FareHarbor!",
        "widgetSlugNotFound": "Widget slug not found, please check the admin interface for the correct slug.",
        "widgetLoadingError": "An error occurred while loading the widget.",
        "bookingCancellationNotAllowedBefore": "Booking cancellation is not allowed within {{time}} hours.",
        "cancelReservationError": "Error while cancelling reservation.",
        "guestCancellationDisabled": "Guest self-cancellation is not allowed for this show.",
        "noOffersSelected": "No offers selected for refund.",
        "noChunksSelected": "No chunks selected for refund.",
        "unknownError": "An unknown error occurred",
        "refundReservationError": "Error while refunding reservation.",
        "invalidAmount": "Invalid refund amount!",
        "maxRefundExceeded": "Max refund amount exceeded!",
        "invalidPaymentMethod": "Invalid payment method",
        "unsupportedPaymentMethod": "Unsupported payment method: {{method}}",
        "notEnoughFundsForRefund": "Not enough funds for refund. Chunk: {{chunkName}}, Amount: {{amount}}",
        "invalidTransactionId": "Invalid transaction ID",
        "transactionNotFound": "Transaction not found",
        "transactionAlreadyFinished": "Transaction is already finished",
        "onlyCashTransactions": "Only cash transactions can be manually finished",
        "transactionMustBeRefunding": "Transaction must belong to a refunding order",
        "noVenueAccess": "You do not have access to this venue",
        "timeslotInPast": "You cannot book a timeslot in the past",
        "bookingWindowClosed": "Booking has closed for this timeslot",
        "timeslotCancelled": "This timeslot has been cancelled and is no longer available for booking",
        "createReservationError": "Error while creating reservation!",
        "createReservationErrorDetails": "We could not create a reservation for you. Please try again later or contact support. The error details are:",
        "blockLimitExceeded": "Block limit exceeded for ticket type",
        "priceMismatch": "Price mismatch",
        "verificationFailed": "Cart verification failed. Please review your selection and try again.",
        "verifying": "Verifying cart...",
        "fieldRequired": "{{field}} is required",
        "customFieldRequired": "\"{{field}}\" is required",
        "generationServiceUnavailable": "Script generation is not available on this server. Set OPENROUTER_API_KEY to enable it.",
        "generationFailed": "Could not generate the script",
        "timeslotHasActiveBookings": "This timeslot has active bookings",
        "timeslotHasOnlyCancelledBookings": "This timeslot has only cancelled bookings",
        "notEnoughSeatsProvided": "Not enough seats provided for ticket type",
        "invalidSeatSelections": "Invalid seat selections provided",
        "invalidPrice": "Invalid price provided",
        "duplicateTimeslotPrice": "Duplicate price entry for the same ticket type and option",
        "errorWhileTryingToPayReservation": "Error while trying to pay reservation",
        "noFilePresentInRequest": "There must be one file present in the request!",
        "invalidSuggestion": "The seating arrangement cannot be granted with the current layout and requirements.",
        "cannotSendSeatingLockEmailBeforeAllAssigned": "Cannot send seating assignment email before all finished bookings have assigned seats",
        "failedToSendSeatingLockEmails": "Failed to send seating assignment emails",
        "failedToSendSeatingChangedEmail": "Failed to send seating-changed email",
        "cannotSendSeatingChangedEmailForNonFinishedBooking": "Seating-changed email can only be sent for finished bookings",
        "noEmailAddress": "This booking has no email address on file",
        "somethingWentWrong": "Something went wrong!",
        "transactionFailed": "Transaction failed!",
        "cannotBuyAlone": "This ticket type cannot be purchased alone. Please select another ticket type as well.",
        "adultTicketRequired": "At least one adult ticket is required when booking child or infant tickets.",
        "cannotMixTicketTypes": "Only one ticket type is allowed per booking on this show.",
        "agentCannotMixTicketTypes": "Your account cannot save bookings that contain more than one ticket type. Same-type upgrades are still allowed.",
        "invalidFormat": "Invalid format",
        "viatorInvalidCredentials": "Viator API credentials are invalid",
        "viatorIntegrationNotFound": "Viator integration not found",
        "timeslotMustBeSameShow": "New timeslot must belong to the same show",
        "invalidRentalSlot": "This ticket option is not available for the selected rental slot",
        "invalidSlotDuration": "Slot duration must be a positive number of minutes",
        "duplicateSlotKey": "Each rental slot must have a unique key",
        "twoFactorAlreadyEnabled": "Two-factor authentication is already enabled for this user",
        "seatNotAvailable": "This seat is not available in the selected arrangement"
    },
    "labelRowsPerPage": "Rows per page",
    "search": "Search",
    "searchPlaceholder": "Search...",
    "common": {
        "minutesAbbr": "min",
        "actions": "",
        "notFound": "Page not found.",
        "noContent": "No content available.",
        "backToLogin": "Back to login",
        "backToHome": "Back to home",
        "accessDenied": "Access denied",
        "logout": "Logout",
        "cancel": "Cancel",
        "close": "Close",
        "clear": "Clear",
        "clearAll": "Clear All",
        "save": "Save",
        "discard": "Discard",
        "showMore": "Show {{count}} more",
        "showLess": "Show less",
        "back": "Back",
        "next": "Next",
        "previous": "Previous",
        "continue": "Continue",
        "yes": "Yes",
        "no": "No",
        "on": "On",
        "off": "Off",
        "none": "None",
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete",
        "apply": "Apply",
        "more": "More",
        "cardView": "Card view",
        "tableView": "Table view",
        "required": "Required",
        "loading": "Loading",
        "all": "All",
        "rebooked": "Rebooked",
        "mustBeGreaterThanZero": "Must be greater than zero",
        "freesoloAutocompletePlaceholder": "Press enter to add new item",
        "requiredFieldsAreNotFilled": "Required fields are not filled",
        "translations": "Translations",
        "language": "Language",
        "set": "Set",
        "languageInfo": "To save the languages, it is not enough to set them here. Please use the save button for the external element as well.",
        "original": "Original",
        "invalidUrl": "Invalid URL",
        "name": "Name",
        "total": "Total",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "changed": "changed",
        "rollback": "Rollback",
        "cancelReservation": "Cancel reservation",
        "refundReservation": "Refund reservation",
        "positiveNumber": "Must be a positive number",
        "pay": "Pay",
        "payWith": "Pay with",
        "remaining": "Remaining",
        "willPayInThisTransaction": "Will pay in this transaction",
        "import": "Import",
        "resend": "Resend",
        "sending": "Sending...",
        "errorLoadingData": "Error loading data",
        "or": "Or",
        "url": "URL",
        "text": "Text",
        "insert": "Insert",
        "maxPercentage": "Must be less than or equal to 100",
        "remove": "Remove",
        "removed": "Removed",
        "startTypingToSearch": "Start typing to search...",
        "noResults": "No results found",
        "recentPaymentMethods": "Recent",
        "searchOrSelectPaymentMethod": "Search or select payment method",
        "export": "Export",
        "error_loading_data": "Error loading data",
        "translated": "Translated successfully",
        "translationError": "Translation failed",
        "translationNotNeeded": "Translation not needed - languages are the same",
        "autoTranslate": "Auto Translate",
        "expandNotes": "Expand notes",
        "placeholder": "Placeholder",
        "manage": "Manage",
        "allTimesIn": "All times in {{timezone}}",
        "copiedToClipboard": "Copied to clipboard",
        "create": "Create",
        "error": "Error",
        "formHasErrors": "Please fix {{count}} error(s) before saving",
        "invalidEmail": "Invalid email address",
        "loadError": "Failed to load data",
        "refund": "Refund",
        "option": "Option"
    },
    "confirmationModal": {
        "title": "Are you sure?",
        "content": "This action cannot be undone."
    },
    "waitlist": {
        "pageTitle": "Waitlist Subscriptions",
        "columns": {
            "subscriberDetails": "Subscriber Details",
            "timeslot": "Timeslot",
            "requested": "Requested",
            "fulfillability": "Fulfillability",
            "activity": "Activity",
            "actions": "Actions"
        },
        "labels": {
            "ticketsTotal": "{{count}} Tickets Total",
            "noPhone": "No phone"
        },
        "status": {
            "ready": "Ready",
            "notEnoughSeats": "Not Enough Seats",
            "neverNotified": "Never notified"
        },
        "activity": {
            "added": "Added: {{-date}}",
            "lastNotified": "Last Notified: {{-date}}",
            "sentTimes": "Sent: {{count}} times"
        },
        "actions": {
            "reminder": "Reminder",
            "sendBulkReminder": "Send Bulk Reminder",
            "deleteConfirm": "Delete this waitlist subscription?",
            "convertToBooking": "Convert to Booking",
            "convertConfirm": "Convert this waitlist entry to a booking? Seats will be auto-assigned and a payment email will be sent to the guest."
        },
        "filters": {
            "show": "Show",
            "timeslot": "Timeslot",
            "allTimeslots": "All timeslots",
            "search": "Search",
            "searchPlaceholder": "Search emails or names...",
            "fulfillableOnly": "Fulfillable only",
            "neverNotifiedOnly": "Never notified only"
        },
        "empty": "There are no waitlist subscriptions yet.",
        "emptyFiltered": "No waitlist subscriptions found for the selected filters.",
        "selectShow": "Select a show above to view waitlist subscriptions.",
        "selectShowAndTimeslot": "Select a show and timeslot above to view waitlist subscriptions.",
        "sendingReminders": "Sending reminders...",
        "notify": {
            "reminderSent": "Reminder sent.",
            "notFulfillable": "Subscription is currently not fulfillable.",
            "notFound": "Subscription not found.",
            "failedReminder": "Failed to send reminder.",
            "deleted": "Subscription deleted.",
            "bulkSent": "Sent {{count}} reminder(s).",
            "bulkSkipped": "Skipped: {{count}}",
            "bulkNotFound": "Not found: {{count}}",
            "bulkFailed": "Failed: {{count}}",
            "convertSuccess": "Booking created. Redirecting to booking page..."
        }
    },
    "paymentModal": {
        "title": "Payment",
        "content": "Please select a payment method to proceed with the payment."
    },
    "login": {
        "title": "Sign-in",
        "email": "Email",
        "password": "Password",
        "login": "Sign-in",
        "forgotPassword": "Forgot password?",
        "forgotPasswordTitle": "Forgot your password?",
        "forgotPasswordButton": "Request password reset email",
        "passwordModified": "Password modified successfully.",
        "passwordRequirements": {
            "length": "The password must be at least 6 characters long",
            "number": "The password must contain a number",
            "lowercase": "The password must contain a lowercase letter",
            "uppercase": "The password must contain an uppercase letter",
            "twoPasswordsMatch": "Passwords must match"
        },
        "wrongEmailFormat": "Invalid email format",
        "newPasswordTitle": "Enter new password",
        "newPassword": "New password",
        "confirmPassword": "Confirm password",
        "resetPassword": "Reset password",
        "resetRequest": "Reset request",
        "forgotPasswordNotifySuccess": "If the email address is registered, you will receive a password reset email.",
        "tiki": {
            "twoFactorTitle": "The Sacred Code",
            "twoFactorDescription": "The fire spirits demand proof. Enter the 6-digit code from your totem.",
            "twoFactorLabel": "Torch Token",
            "twoFactorSubmit": "Light the Torch",
            "twoFactorLoading": "Reading the flames...",
            "twoFactorError": "The spirits rejected your code. Try again, warrior."
        }
    },
    "auditlogs": {
        "title": "Audit logs",
        "eventCount": "{{count}} events",
        "unknownLogType": "Unknown log type",
        "columns": {
            "venueName": "Venue name",
            "userName": "User name",
            "logType": "Log type",
            "created": "Created",
            "logData": "Log data"
        },
        "expandForDetailed": "Expand for detailed version.",
        "closeForBriefVersion": "Close for brief version."
    },
    "capabilities": {
        "title": "Default Capabilities",
        "sectionTitle": "Capabilities",
        "userSectionSubtitle": "Manage specific access rights and permissions for this user.",
        "superadminBypass": "Superadmin users have full access to all features regardless of capability settings. No configuration is needed.",
        "permissions": "Permissions",
        "enabled": "Enabled",
        "saveChanges": "Save Changes",
        "custom": "Custom",
        "resetToDefaults": "Reset to Default",
        "templateDescription": "Select a preset to quickly assign permissions, or customize individually below.",
        "templates": "Quick Templates",
        "templatesSubtitle": "Click a template to pre-fill capabilities, then customize as needed.",
        "templateActive": "Active",
        "roleCapabilities": "{{role}} Capabilities",
        "panelSubtitle": "Configure access levels and permissions for this role.",
        "status": "Status",
        "statusCustomized": "Customized",
        "missingDependency": "Requires: {{deps}}",
        "groups": {
            "venues": "Venues",
            "shows": "Shows",
            "bookings": "Bookings",
            "operations": "Operations",
            "users": "Users",
            "payment_methods": "Payment Methods",
            "coupons": "Coupons",
            "integrations": "Integrations",
            "commission_groups": "Commission Groups",
            "reports_invoices": "Reports & Invoices",
            "invoices": "Invoices",
            "logs": "Logs",
            "reports": "Report Access",
            "payments": "Payments",
            "system": "System"
        },
        "groupsSubtitles": {
            "venues": "List and details",
            "shows": "Events management",
            "bookings": "Manage booking flows",
            "operations": "Catering and check-in",
            "users": "Team management",
            "payment_methods": "Card processing",
            "coupons": "Discount codes",
            "integrations": "Third-party connections",
            "commission_groups": "Agent rates",
            "reports_invoices": "Financial data",
            "invoices": "Invoice management",
            "logs": "Audit and email logs",
            "reports": "Per-report access",
            "payments": "Payment overrides",
            "system": "Global settings"
        },
        "groupPermissionsSubtitle": {
            "bookings": "Control access to booking creation, modification, and refunds.",
            "venues": "View and manage venue settings.",
            "shows": "Control access to show and event management.",
            "operations": "Access catering and check-in views.",
            "users": "Manage team members and roles.",
            "payment_methods": "Configure payment methods.",
            "coupons": "Create and manage discount codes.",
            "integrations": "Configure external integrations.",
            "commission_groups": "Manage agent commission rates.",
            "reports_invoices": "Access financial reports and invoices.",
            "invoices": "Access invoice reports.",
            "logs": "View audit and email logs.",
            "reports": "Control access to individual report types.",
            "system": "System-level administration."
        },
        "caps": {
            "venues_view": {
                "label": "View Venues",
                "description": "View venue list and details"
            },
            "venues_manage": {
                "label": "Manage Venues",
                "description": "Create, edit, and delete venues"
            },
            "shows_view": {
                "label": "View Shows",
                "description": "View show list and details"
            },
            "shows_manage": {
                "label": "Manage Shows",
                "description": "Create, edit, and delete shows"
            },
            "timeslots_view_hidden": {
                "label": "See hidden timeslots",
                "description": "See and book timeslots hidden from the widget, integrations, and commission groups. For internal agents and admins only."
            },
            "bookings_view": {
                "label": "View Bookings",
                "description": "View booking list and details"
            },
            "bookings_manage": {
                "label": "Manage Bookings",
                "description": "Create and edit bookings"
            },
            "bookings_refund": {
                "label": "Refund Bookings",
                "description": "Process booking refunds"
            },
            "bookings_import": {
                "label": "Import Bookings",
                "description": "Bulk import bookings"
            },
            "bookings_scope_all": {
                "label": "View All Bookings",
                "description": "View bookings from all agents (without this, only own bookings are visible)"
            },
            "catering_view": {
                "label": "Catering View",
                "description": "Access the catering view"
            },
            "checkin_view": {
                "label": "Check-in View",
                "description": "Access the check-in view"
            },
            "checkin_finish": {
                "label": "Finish Check-in",
                "description": "Close and reopen check-in for a timeslot"
            },
            "users_manage": {
                "label": "Manage Users",
                "description": "Create, edit, and delete users"
            },
            "payment_methods_view": {
                "label": "View Payment Methods",
                "description": "View payment methods"
            },
            "payment_methods_manage": {
                "label": "Manage Payment Methods",
                "description": "Create, edit, and delete payment methods"
            },
            "coupons_view": {
                "label": "View Coupons",
                "description": "View coupon list and details"
            },
            "coupons_manage": {
                "label": "Manage Coupons",
                "description": "Create and delete coupons"
            },
            "integrations_manage": {
                "label": "Manage Integrations",
                "description": "Configure integrations"
            },
            "commission_groups_view": {
                "label": "View Commission Groups",
                "description": "View commission groups"
            },
            "commission_groups_manage": {
                "label": "Manage Commission Groups",
                "description": "Create, edit, and delete commission groups"
            },
            "waitlist_manage": {
                "label": "Manage Waitlist",
                "description": "Manage the waitlist"
            },
            "upgrade_manage": {
                "label": "Manage Upgrades",
                "description": "Manage upgrade paths and send upgrade offers"
            },
            "reports_view": {
                "label": "View Reports",
                "description": "Access sales and other reports"
            },
            "invoices_view": {
                "label": "View Invoices",
                "description": "Access invoice reports"
            },
            "logs_view": {
                "label": "View Logs",
                "description": "View audit and email logs"
            },
            "reports_sales_view": {
                "label": "View Sales Report",
                "description": "Access the sales report"
            },
            "reports_sales_export": {
                "label": "Export Sales Report",
                "description": "Download the sales report as a file"
            },
            "reports_transactions_view": {
                "label": "View Transactions Report",
                "description": "Access the transactions report"
            },
            "reports_transactions_export": {
                "label": "Export Transactions Report",
                "description": "Download the transactions report as a file"
            },
            "reports_manifest_view": {
                "label": "View Manifest Report",
                "description": "Access the manifest report"
            },
            "reports_manifest_export": {
                "label": "Export Manifest Report",
                "description": "Download the manifest report as a file"
            },
            "reports_commission_view": {
                "label": "View Commission Report",
                "description": "Access the commission report"
            },
            "reports_commission_export": {
                "label": "Export Commission Report",
                "description": "Download the commission report as a file"
            },
            "reports_affiliate_sales_view": {
                "label": "View Affiliate Sales Report",
                "description": "Access the affiliate sales report"
            },
            "reports_affiliate_sales_export": {
                "label": "Export Affiliate Sales Report",
                "description": "Download the affiliate sales report as a file"
            },
            "reports_affiliate_invoice_view": {
                "label": "View Affiliate Invoice Report",
                "description": "Access the affiliate invoice report"
            },
            "reports_affiliate_invoice_export": {
                "label": "Export Affiliate Invoice Report",
                "description": "Download the affiliate invoice report as a file"
            },
            "reports_payout_view": {
                "label": "View Payout Report",
                "description": "Access the payout report"
            },
            "reports_payout_export": {
                "label": "Export Payout Report",
                "description": "Download the payout report as a file"
            },
            "reports_booking_fee_view": {
                "label": "View Booking Fee Report",
                "description": "Access the booking fee report"
            },
            "reports_booking_fee_export": {
                "label": "Export Booking Fee Report",
                "description": "Download the booking fee report as a file"
            },
            "reports_affiliate_cancelled_refunded_view": {
                "label": "View Affiliate Cancelled/Refunded Report",
                "description": "Access the report of cancelled and refunded affiliate bookings"
            },
            "reports_affiliate_cancelled_refunded_export": {
                "label": "Export Affiliate Cancelled/Refunded Report",
                "description": "Download the cancelled/refunded affiliate bookings report as a file"
            },
            "seating_modify": {
                "label": "Modify Booking Seats",
                "description": "Change seat assignments on individual bookings"
            },
            "seating_cross_ticket_type": {
                "label": "Cross-Type Seat Assignment",
                "description": "Assign seats to mismatched ticket types (manager override)"
            },
            "seating_assignments": {
                "label": "Mass Seat Assignments",
                "description": "Access the timeslot mass-seating page to assign or move seats across bookings"
            },
            "bookings_simplified_tickets": {
                "label": "Simple Booking Editor",
                "description": "Lock to simplified ticket view with no seat map or price editing"
            },
            "bookings_modify_past": {
                "label": "Modify Past Event Bookings",
                "description": "Edit bookings (reschedule, change pax, modify tickets) after the event start time has passed"
            },
            "bookings_show_stats": {
                "label": "View Booking Statistics",
                "description": "View booking statistics"
            },
            "bookings_overbook": {
                "label": "Overbook",
                "description": "Bypass seat-count and reserved-capacity checks when creating or modifying bookings"
            },
            "bookings_cross_selling": {
                "label": "Allow Cross Selling",
                "description": "Save booking modifications that contain more than one ticket type. Without this, agents are limited to a single ticket type per booking; same-type upgrades remain allowed."
            },
            "bookings_custom_rollback_times": {
                "label": "Custom Rollback Times",
                "description": "Set custom rollback time windows for bookings. Allows overriding default cancellation/rollback time limits per booking."
            },
            "bookings_always_refund": {
                "label": "Override Cancel Window on Refund",
                "description": "Permits cancelling with a refund even after the show's cancel window has closed. The agent must explicitly opt in per booking — the override is not silently applied. Invoiced bookings remain locked regardless."
            },
            "bookings_re_source": {
                "label": "Re-source Booking",
                "description": "Re-source a booking to a different agent and switch a transaction's payment type between same-fee on-house payment methods."
            },
            "bookings_cancel": {
                "label": "Cancel Bookings",
                "description": "Cancel bookings. Without this capability, the cancel action is hidden and blocked at the API level. External agents do not have this by default."
            },
            "bookings_bypass_dynamic_pricing": {
                "label": "Bypass Dynamic Pricing",
                "description": "Book at the original (timeslot/default) price even when a dynamic-pricing integration is enabled. Default for admins only."
            },
            "payments_split_unlimited": {
                "label": "Unlimited Split Payments",
                "description": "Override the venue's max split payment limit. Allows splitting a booking payment into any number of parts regardless of venue settings."
            }
        }
    },
    "venues": {
        "model": "Venue",
        "title": "Venues",
        "singleTitle": "Venue",
        "columns": {
            "name": "Name",
            "site": "Site",
            "availableLanguages": "Available languages",
            "allowedSplitPaymentAmount": "Max split payments",
            "slug": "Slug",
            "tax": "Tax (%)",
            "invoiceRemitToName": "Invoice remittance entity"
        },
        "allowedSplitPaymentAmountHelp": "Max number of payments an order can be split into. 0 = unlimited, 1 = no splits allowed.",
        "invoiceRemitToNameHelp": "Override the legal entity name printed on affiliate invoices and statements. Leave blank to use the venue name.",
        "newVenueTitle": "New venue",
        "importTitle": "Import from FareHarbor",
        "importH2": "Import by providing a slug",
        "defaultName": "New venue",
        "defaultSlug": "newvenue",
        "defaultSite": "New site",
        "isCurrent": "Active",
        "noVenues": "No venues available.",
        "notifications": {
            "added": "Venue added successfully.",
            "updated": "Venue updated successfully.",
            "deleted": "Venue deleted successfully.",
            "deleteError": "Venue cannot be deleted.",
            "importSuccess": "Venue data imported successfully."
        }
    },
    "users": {
        "model": "User",
        "title": "Users",
        "columns": {
            "name": "Name",
            "email": "Email",
            "role": "Role",
            "venueName": "Venue"
        },
        "roleLabels": {
            "superadmin": "Superadmin",
            "user": "User",
            "admin": "Admin",
            "manager": "Manager",
            "agent": "Agent",
            "external_agent": "External Agent",
            "executive": "Executive",
            "guest": "Guest",
            "accountant": "Accountant",
            "caterer": "Caterer"
        },
        "venueSelect": "Venue",
        "newUserTitle": "New user",
        "notifications": {
            "added": "Invitation email has been sent, the user has been added to the venue!",
            "updated": "User updated successfully.",
            "deleted": "User deleted successfully from the venue.",
            "deleteError": "User cannot be deleted.",
            "switchVenue": "Switched into venue",
            "profileUpdated": "User profile updated",
            "twoFactorReset": "Two-factor authentication reset successfully",
            "twoFactorDisabled": "Two-factor authentication disabled successfully"
        },
        "switchToVenue": "Switch to venue",
        "myProfile": "My profile",
        "switchVenueDescription": "You can switch to another venue by clicking on the venue name.",
        "noVenues": "No venues available.",
        "userDetails": "User details",
        "myDetails": "My details",
        "security": "Security",
        "enableTwoFactor": "Enable Two factor authentication",
        "enableTwoFactorPlaceholderDescription": "Scan the QR code below with your authenticator app (Google Authenticator, Authy, etc.).",
        "enterTwoFactorCode": "Enter the 6-digit code from your app:",
        "twoFactorVerification": "Two-factor verification",
        "enterTwoFactorCodeDescription": "Please enter the 6-digit code from your authenticator app to continue.",
        "invalidTwoFactorCode": "Invalid 2FA code. Please try again.",
        "twoFactorEnabled": "Two-factor authentication enabled successfully!",
        "disableTwoFactor": "Disable Two factor authentication",
        "disableTwoFactorConfirm": "Are you sure you want to disable two-factor authentication? Your account will be less secure.",
        "resetTwoFactor": {
            "title": "Reset two factor authentication",
            "subtitle": "You can reset the user's two factor authentication here.",
            "forceResetTitle": "Reset 2FA",
            "forceResetDescription": "This will disable 2FA for this user until they set it up again.",
            "button": "Reset 2FA"
        },
        "passwordOverride": {
            "title": "Password override",
            "warning": "This immediately overwrites the user's login password.",
            "generatedPassword": "Generated password",
            "setRandomButton": "Set random password",
            "copyButton": "Copy password",
            "copyShort": "Copy",
            "subtitle": "Update login credentials for this user.",
            "statusActive": "Active",
            "warningTitle": "Password override warning",
            "forceResetTitle": "Force password reset",
            "forceResetDescription": "Immediately resets the user password with a secure server-side secret.",
            "generateNewButton": "Generate password",
            "successInfo": "Password generated successfully. Please copy it now.",
            "lastChangedNone": "Last changed: -",
            "lastChangedBy": "Last changed: {{date}} by {{name}}",
            "lastChangedByForgottenPassword": "Last changed: {{date}} by {{name}} (via Forgot password)",
            "confirmTitle": "Confirm password override",
            "confirmRandom": "Are you sure you want to generate and set a random password for the user?",
            "notifications": {
                "randomSet": "Password has been reset successfully.",
                "randomSetCopied": "Password has been reset and copied to clipboard.",
                "copied": "Password copied to clipboard."
            }
        },
        "tabs": {
            "profileDetails": "Profile Details",
            "capabilitiesPermissions": "Capabilities & Permissions",
            "securityAccess": "Security & Access"
        }
    },
    "shows": {
        "model": "Show",
        "title": "Shows",
        "columns": {
            "title": "Title",
            "subtitle": "Subtitle",
            "description": "Description",
            "cancelWindow": "Cancellation window (hrs)",
            "cancelDescription": "Cancellation policy",
            "needToKnow": "Need to know",
            "location": "Location",
            "countryCode": "Country",
            "destinationCode": "Destination (City/Location)",
            "destinationCodeHelper": "Please select a country first",
            "venueName": "Venue name",
            "enabledAbandonedCartEmail": "Send out abandoned cart email",
            "guestCancellationEnabled": "Allow guest self-cancellation",
            "cancellationReasonsTitle": "Pre-configured cancellation reasons",
            "cancellationReasonColor": "Cancelled timeslot color",
            "cancellationReasonColorReset": "Reset to default color",
            "cancellationReasonTitle": "Title",
            "cancellationReasonSubtext": "Description",
            "reservationTime": "Reservation time (minutes)",
            "reviewText": "Review text",
            "reviewLink": "Review link (SMS)",
            "tripadvisorUrl": "Tripadvisor URL",
            "timeslotManagement": "Timeslot management",
            "iCalUrl": "iCal URL",
            "autoPublishDaysInAdvance": "Automatically publish (days in advance)",
            "rollbackTimeSize": "Rollback time size (minutes)",
            "rollbackTimeSizeHelp": "= {{hours}}h {{minutes}}m",
            "bookingWindow": "Booking window (hours)",
            "bookingWindowHelp": "Guests cannot book within {{hours}}h of the show start",
            "marketing": {
                "logo": "Logo",
                "primaryImage": "Primary image",
                "extraImages": "Extra images",
                "subheadline": "Subheadline",
                "tags": "Tags",
                "duration": "Duration (hours)",
                "location": "Location",
                "email": "Email",
                "phone": "Phone",
                "tracking": {
                    "ga4": "Google Analytics 4 ID",
                    "facebook": "Facebook Pixel ID",
                    "tiktok": "TikTok Pixel ID",
                    "linkedin": "LinkedIn Partner ID",
                    "twitter": "Twitter Pixel ID",
                    "snapchat": "Snapchat Pixel ID",
                    "pinterest": "Pinterest Tag ID"
                }
            },
            "senderEmailPrefix": "Sender email address",
            "senderEmailPrefixHelper": "Email address used as the sender for show-related emails. Defaults to no-reply.",
            "delayedSeatAssignmentEnabled": "Disable seat selection (widget + admin auto-assignment)",
            "delayedSeatAssignmentUseSeatIdsInEmails": "Email seat IDs (otherwise send table IDs only)",
            "allowCrossTicketBuying": "Allow buying different ticket types in one transaction",
            "absorbProcessingFee": "Absorb card processing fee (merchant pays it)",
            "allowSeatingGroupRequest": "Let guests ask to be seated with friends",
            "rentalMode": "Rental mode (cabana / sunbed rentals with configurable slots)",
            "slotTemplateTitle": "Rental slots",
            "slotTemplateHint": "Define the slots offered per rental day. Each slot becomes one timeslot; seats conflict between slots whose time ranges overlap.",
            "slotTemplateRentalOffHint": "Turn on rental mode to configure rental slots.",
            "slotTemplateAdd": "Add slot",
            "slotTemplateLabel": "Label",
            "slotTemplateStartTime": "Start time",
            "slotTemplateDuration": "Duration (minutes)",
            "slotTemplateIsFullDay": "Full-day slot",
            "slotTemplateRemove": "Remove slot",
            "slotTemplateMoveUp": "Move up",
            "slotTemplateMoveDown": "Move down",
            "slotTemplateDuplicateKey": "Slot labels must be unique",
            "requireAdultTicket": "Carts require at least one adult ticket (child/infant cannot book alone)",
            "waitlistNotificationEmailsLabel": "Waitlist notification emails",
            "waitlistNotificationEmailsHelp": "Addresses entered here get an email when a waitlist entry on this show becomes fulfillable.",
            "waitlistNotificationEmailsInvalid": "Please enter a valid email address",
            "checkinNotificationEmailsLabel": "Check-in notification emails",
            "checkinNotificationEmailsHelp": "Addresses entered here get a notification related to check-in events for this show.",
            "checkinNotificationEmailsInvalid": "Please enter a valid email address",
            "isBreakingOutFees": "Breaking out fees and taxes",
            "priceListingMode": "Ticket price listing",
            "fees": "Fees",
            "feesAttributes": {
                "name": "Name",
                "percentage": "Percentage",
                "usd": "USD amount",
                "isTax": "Is Tax",
                "onlineOnly": "Online Only"
            },
            "bookingFeeRebateShare": "Booking fee venue rebate",
            "bookingFeeRebateShareHelp": "Share of this show's booking fees rebated to the venue (e.g. 30). Leave empty for none.",
            "upgradeNotificationEmailsLabel": "Upgrade notification emails",
            "upgradeNotificationEmailsHelp": "Comma-separated email addresses notified when bookings become eligible for an upgrade.",
            "upgradeNotificationEmailsInvalid": "Invalid email in upgrade notification list"
        },
        "timeslotManagementValues": {
            "iCalSync": "iCal sync",
            "manual": "Manual timeslot management"
        },
        "feeDisplayModes": {
            "noBreakdown": "No breakdown (final prices only)",
            "simpleBreakdown": "Simple breakdown (Taxes & Fees combined)",
            "detailedBreakdown": "Detailed breakdown (itemized)"
        },
        "priceListingModes": {
            "gross": "Gross (price includes fees & taxes)",
            "net": "Net (price excludes fees & taxes; sidebar shows booking fee + processing fee)"
        },
        "cancelableAnyTime": "Cancelable any time",
        "cancelUnit": "hours",
        "newShowTitle": "New show",
        "defaultTitle": "New title",
        "defaultDescription": "New description",
        "notifications": {
            "added": "Show added successfully.",
            "updated": "Show updated successfully.",
            "deleted": "Show deleted successfully.",
            "deleteError": "Show cannot be deleted."
        },
        "validation": {
            "reservationTimeMin": "Reservation time must be greater than or equal to 5",
            "rollbackTimeSize": "Rollback time must be greater than or equal to 5 minutes"
        },
        "marketingTitle": "Marketing",
        "bookingBehaviorGroup": "Booking behavior",
        "notificationsGroup": "Notifications",
        "addCancellationReason": "Add reason",
        "pricingDisplayGroup": "Pricing display",
        "contactVenue": "Contact venue",
        "mainInfoTitle": "Main info",
        "detailsTitle": "Show details",
        "otherInfoTitle": "Other information",
        "settingsTitle": "Settings",
        "settingsTabs": {
            "general": "General",
            "bookingRules": "Booking rules",
            "content": "Content & policies",
            "notifications": "Notifications",
            "pricing": "Pricing"
        },
        "feesTitle": "Fees",
        "trackingTitle": "Analytics & Tracking",
        "trackingDescription": "Configure marketing platform tracking IDs for this show. Leave fields empty if not using a particular platform.",
        "stylingTabTitle": "Styling",
        "stylingTitle": "Widget styling",
        "stylingDescription": "Override widget colors for this show. Leave a field empty to fall back to the default. Values must be hex colors (e.g. #ff0033).",
        "stylingResetAll": "Reset all",
        "stylingInvalidHex": "Use a hex color like #ff0033",
        "stylingFields": {
            "primary": "Primary accent",
            "primary-bg": "Primary button background",
            "primary-bg-active": "Primary button background (pressed)",
            "primary-bg-hover-and-focus": "Primary button background (hover/focus)",
            "primary-color": "Primary button text",
            "secondary": "Secondary accent",
            "featured-card-bg": "Featured card background",
            "featured-card-color": "Featured card text",
            "header-color": "Header color",
            "default-color": "Body text color",
            "default-bg": "Page background"
        },
        "stylingBasicsTitle": "Basics",
        "stylingAdvancedTitle": "Advanced color overrides",
        "stylingFontsTitle": "Fonts",
        "stylingFontsDescription": "Pick from the list, or type any Google Fonts family name (e.g. \"Crimson Text\", \"JetBrains Mono\") and press Enter. The widget loads the font from Google Fonts at runtime. Inter is bundled locally. Unknown names fall back silently to the default.",
        "stylingFontHeader": "Heading font",
        "stylingFontBody": "Body font",
        "stylingNightMode": "Night mode",
        "stylingNightModeAuto": "Follow system",
        "stylingNightModeLight": "Always light",
        "stylingNightModeDark": "Always dark",
        "stylingSurpriseMe": "Surprise me",
        "verification": {
            "tabTitle": "Verification",
            "title": "Cart verification script",
            "description": "Optional JavaScript expression evaluated server-side on every cart change. Use it to enforce booking rules (e.g. \"lap-child cannot be bought alone\") or apply conditional adjustments to the total.",
            "helpHeader": "The script receives an `input` object with the full cart, totals, contact info, coupon, payment method (when picked) and language. It must either return a number (delta in cents, +/-) or throw an Error with a numeric `code` to reject the cart. Codes are mapped to the messages below.",
            "helpExample": "if (input.cart.find(i => i.ticketOptionName === 'Lap child') && input.cart.length === 1) {\n  const e = new Error(); e.code = 801; throw e;\n}\nreturn 0;",
            "scriptLabel": "Verification script",
            "scriptPlaceholder": "// return 0; // no-op",
            "messagesTitle": "Error messages by code",
            "messagesDescription": "When the script throws with a numeric code, the matching message for the buyer's language is shown. Add the same code in each language you support; English is used as a fallback.",
            "noMessages": "No error messages defined yet. Add one for each code your script can throw.",
            "codeLabel": "Code",
            "messageLabel": "Message",
            "addMessage": "Add error code",
            "promptTitle": "Describe the rule",
            "promptDescription": "Write what the rule should do in plain English. We turn it into a script using an LLM. The prompt is saved with the show so you can iterate later.",
            "promptLabel": "Prompt",
            "promptPlaceholder": "e.g. Require at least 2 parking tickets when any parking ticket is in the cart. Use error code 901.",
            "generateButton": "Generate from prompt",
            "regenerateButton": "Regenerate from prompt",
            "generating": "Generating...",
            "generationSuccess": "Verification script generated. Existing script was replaced; new error messages were merged with existing ones. Review the Advanced section and save the show.",
            "generationBehaviorHint": "Generating replaces the script entirely; new error messages are merged into the existing list (existing codes are kept).",
            "advancedToggle": "Advanced (script & messages)",
            "lockedChip": "Manually edited",
            "generatedChip": "Generated from prompt",
            "lockedConfirmTitle": "Overwrite manual edits?",
            "lockedConfirmBody": "The current script has been edited by hand after the last generation. Generating again will replace it. Continue?",
            "helpPromptLabel": "Prompt the script was generated from",
            "helpInputLabel": "Shape of `input` passed into the script (also given to the LLM)",
            "translationsTitle": "Translations for code {{code}}",
            "translationsHint": "Edit per-language messages, or click the spark icon to translate the English text via the LLM.",
            "translationsSourceLabel": "English message (source)",
            "translationsNoLanguages": "This venue only supports English. Add more languages on the venue to enable translations.",
            "translateButton": "Translate from English",
            "translateMissingSource": "Type an English message before translating.",
            "formatScript": "Format script",
            "copyScript": "Copy script",
            "copyAck": "Copied!",
            "testRunTitle": "Test run (sandboxed, in-browser)",
            "testInputLabel": "Sample input (JSON)",
            "testResultLabel": "Result",
            "testReset": "Reset to sample",
            "testRun": "Run test",
            "testIdle": "Click \"Run test\" to evaluate the script against the sample input.",
            "testEmpty": "Script is empty — generate or write one first.",
            "testBadInput": "Sample input is not valid JSON",
            "testReturned": "Script returned",
            "testThrown": "Script threw",
            "testThrownCode": "Script threw (code {{code}})",
            "testElapsed": "Ran in {{ms}}ms"
        },
        "feesInfo": "Fees are applied on the ticket net, taxes are applied on net + fees. Payment fees are on top of net + fees + taxes.",
        "feesValidation": "One of percentage or USD amount must be provided and greater than zero for each fee.",
        "noShows": "No shows found",
        "actionGroups": {
            "tickets": "Tickets",
            "scheduling": "Schedule & Promotions",
            "system": "System",
            "manage": "Manage",
            "commissionGroups": "Commission Groups"
        }
    },
    "ticketoptions": {
        "model": "Ticket option",
        "title": "Ticket options",
        "columns": {
            "name": "Name",
            "description": "Description",
            "showTitle": "Show title",
            "ageBand": "Age band",
            "guestVisible": "Guest visible",
            "timeslotPeriod": "Rental slot"
        },
        "timeslotPeriod": {
            "allPeriods": "All slots"
        },
        "ageBand": {
            "notDefined": "Not defined",
            "adult": "Adult",
            "child": "Child",
            "youth": "Youth",
            "infant": "Infant",
            "senior": "Senior"
        },
        "newTicketOptionName": "New ticket option",
        "defaultName": "New name",
        "defaultDescription": "New description",
        "reorderMode": "Reorder ticket options",
        "notifications": {
            "added": "Ticket option added successfully.",
            "updated": "Ticket option updated successfully.",
            "deleted": "Ticket option deleted successfully.",
            "deleteError": "Ticket option cannot be deleted.",
            "reorderSaved": "Ticket option order saved.",
            "reorderError": "Failed to save ticket option order."
        }
    },
    "tickettypes": {
        "model": "Ticket type",
        "title": "Ticket types",
        "columns": {
            "name": "Name",
            "description": "Description",
            "showTitle": "Show title",
            "showInList": "Show in list",
            "canBuyAlone": "Can buy alone",
            "priceMatrix": "Price matrix",
            "guestVisible": "Guest visible",
            "automaticSeating": "Automatic seating",
            "customFields": "Custom fields",
            "ticketSeats": "Ticket seats",
            "blockLimit": "Block limit",
            "checkinTimeBeforeStart": "Check-in time before start (minutes)",
            "color": "Color"
        },
        "automaticSeating": {
            "manual": "Manual seating",
            "auto": "Suggested seating",
            "fullauto": "Automatic seating"
        },
        "customFieldsAttributes": {
            "type": "Type",
            "name": "Name",
            "description": "Description",
            "required": "Required",
            "showInCatering": "Show in catering view"
        },
        "customFieldsTypes": {
            "singleLine": "Single line",
            "multiLine": "Multi line",
            "dropdown": "Dropdown"
        },
        "addNewNote": "Add new note",
        "newNoteName": "New note name",
        "newNoteDescription": "New note description",
        "removeNote": "Remove note",
        "additionalInformation": "Additional information",
        "requiredFieldsEmpty": "Required fields not filled: {{fields}}",
        "noFreeSeatsAvailable": "No free seats available",
        "freeTicketSeatNumber": "Free seats available",
        "newTicketTypeName": "New ticket type",
        "defaultName": "New name",
        "defaultDescription": "New description",
        "reorderMode": "Reorder ticket types",
        "notifications": {
            "added": "Ticket type added successfully.",
            "updated": "Ticket type updated successfully.",
            "deleted": "Ticket type deleted successfully.",
            "deleteError": "Ticket type cannot be deleted.",
            "reorderSaved": "Ticket type order saved.",
            "reorderError": "Failed to save ticket type order."
        },
        "priceMatrixValueNameLabel": "Name",
        "priceMatrixValuePriceLabel": "Price",
        "noPriceMatrix": "No price matrix",
        "noCustomFields": "No additional information",
        "priceMatrixWarning": "Please check that the correct ticket names and prices are listed in the price matrix. The values in the price matrix are only displayed during ticket purchase.",
        "customFieldsInfo": "Custom fields are used to collect additional information from the user during ticket purchase. You can add custom fields to the ticket type and set them as required or optional.",
        "wrongPriceCalculation": "Wrong price calculation!",
        "improvedPriceMatrixInfo": "Enter prices for each ticket option. Leave empty for unavailable combinations (empty means no combination, even 0 is a valid price).",
        "errorLoadingTicketOptions": "Error loading ticket options for this show.",
        "noTicketOptionsAvailable": "No ticket options are available for this show. Please add ticket options first.",
        "ticketOption": "Ticket Option",
        "price": "Price",
        "noPrice": "No price",
        "ticketType": "Ticket Type",
        "listView": "List View",
        "matrixView": "Matrix View",
        "priceMatrixViewInfo": "Set prices for each combination of ticket type and option.",
        "priceMatrixEmptyState": "Get started by adding your first ticket type and ticket option below.",
        "noTicketTypesHint": "Add your first ticket type below.",
        "noTicketOptionsHint": "Add your first ticket option in the header row.",
        "matrixSaved": "Price matrix saved successfully!",
        "errorLoadingData": "Error loading data.",
        "noTicketTypes": "No ticket types available for this show.",
        "noTicketOptions": "No ticket options available for this show.",
        "noTimeslots": "No timeslots available for this show.",
        "noBlockLimit": "No limit",
        "blockLimitInfo": "Maximum number of tickets sellable per timeslot for guests. Leave empty for no limit.",
        "checkinTimeBeforeStartInfo": "How many minutes before the show start guests with this ticket type should check in. Use 0 to use the show start time.",
        "colorInfo": "Color used to represent this ticket type in the seating chart. You should use hex color codes (e.g., #FF5733).",
        "seatMapHintClick": "Click a seat to toggle selection.",
        "seatMapHintShift": "Hold Shift and drag to select multiple seats."
    },
    "seats": {
        "model": "Seat",
        "title": "Seats",
        "importTitle": "Import Seating",
        "importSuccess": "Seating imported successfully.",
        "cloneTitle": "Clone Seating",
        "cloneDescription": "Select a venue and a show where you want to clone this seating.",
        "cloneSuccess": "Seating cloned successfully.",
        "columns": {
            "id": "ID",
            "name": "Name",
            "x": "X",
            "y": "Y",
            "rotation": "Rotation",
            "scale": "Scale",
            "bookable": "Bookable",
            "model": "Model"
        },
        "upload": {
            "uploadTitle": "Upload Seating",
            "uploadFormats": "Supported format: XLSX"
        },
        "notifications": {
            "added": "Seat added successfully.",
            "updated": "Seat updated successfully.",
            "deleted": "Seat deleted successfully.",
            "deleteError": "Seat cannot be deleted.",
            "createError": "Seat cannot be created.",
            "updateError": "Seat cannot be updated.",
            "exportSuccess": "Seats exported successfully.",
            "arrangementAdded": "Arrangement created",
            "arrangementDeleted": "Arrangement deleted",
            "arrangementError": "Failed to update arrangement"
        },
        "import": {
            "toAdd": "Seats to add",
            "toUpdate": "Seats to update",
            "toDelete": "Seats to delete",
            "errorsFound": "Errors found in the imported data. Please fix them before saving.",
            "status": "Status",
            "changes": "Changes",
            "customModel": "Custom",
            "noChangesFound": "No executable changes were found."
        },
        "validation": {
            "xNumber": "X must be a number",
            "yNumber": "Y must be a number",
            "rotationNumber": "Rotation must be a number",
            "rotationRange": "Rotation must be between -360 and 360",
            "invalidModel": "Invalid model: {{model}}",
            "bookableBoolean": "Bookable must be a boolean",
            "idNotFound": "Seat has an ID but wasn't found in current show; a new one will be created.",
            "missingIdForDelete": "Seat to delete is missing its ID."
        },
        "arrangements": "Arrangements",
        "defaultArrangement": "Default",
        "addArrangement": "Add arrangement",
        "arrangementName": "Arrangement name",
        "activeArrangement": "Active seating arrangement",
        "removeFromArrangement": "Remove from arrangement",
        "active": "Active",
        "deleteArrangementConfirm": "Are you sure you want to delete this arrangement? This cannot be undone."
    },
    "timeslots": {
        "model": "Timeslot",
        "title": "Timeslots",
        "full": "Full",
        "available": "Available (>{{threshold}})",
        "limited": "Limited (1-{{threshold}})",
        "soldOut": "Full (0)",
        "capacityReservations": "Bookable seats",
        "capacityReservationsInfo": "Set how many seats can be booked per ticket type. Lowering it below the already-sold count may require manually cancelling bookings or moving them to other timeslots.",
        "bookableHeader": "Bookable",
        "totalHeader": "Total",
        "checkinClosedBanner": "Check-in for this timeslot has been closed. The recon summary has been recorded.",
        "columns": {
            "showTitle": "Show title",
            "startTime": "Start time",
            "isReviewEmailSuppressed": "Suppress review emails",
            "timeslotPeriod": "Rental slot",
            "timeslotPeriodNone": "None (standard event)",
            "timeslotGroupId": "Rental day group ID",
            "timeslotGroupIdHint": "Links the slot timeslots for the same rental day. Leave blank for standard timeslots.",
            "isHidden": "Hidden timeslot",
            "note": "Note"
        },
        "isHiddenHelp": "Hidden from the widget, integrations and commission groups. Only users with the \"See hidden timeslots\" capability can see and book it.",
        "newTimeslotName": "New timeslot",
        "bulkAddName": "Bulk add timeslots",
        "createRentalDay": "Create rental day",
        "createRentalDayHint": "Creates the configured rental slots for the selected date and groups overlapping slots for conflict detection.",
        "editRentalDay": "Edit rental day",
        "editRentalDayHint": "Change the date and slot times for this rental day. All bookings move with their timeslots.",
        "bulkRentalDaysName": "Bulk add rental days",
        "rentalDate": "Rental date",
        "changeTimeslot": "Change Timeslot",
        "cancelTimeslotButton": "Cancel Timeslot",
        "uncancelTimeslotButton": "Remove Cancellation",
        "cancelledTitle": "This event has been cancelled",
        "cancelledBanner": "This timeslot is cancelled",
        "cancelModal": {
            "title": "Cancel Timeslot",
            "customReasonLabel": "Custom reason",
            "confirm": "Confirm Cancellation"
        },
        "bulkAdd": {
            "title": "Recurring schedule",
            "daysLabel": "Days of week",
            "timeLabel": "Time",
            "startDateLabel": "Start date",
            "endDateLabel": "End date",
            "endAfterStart": "End date must be on or after start date",
            "preview": "{{count}} matching date (existing timeslots are skipped)",
            "preview_plural": "{{count}} matching dates (existing timeslots are skipped)",
            "progressLabel": "{{completed}} / {{total}} processed ({{percent}}%)",
            "days": {
                "0": "Sun",
                "1": "Mon",
                "2": "Tue",
                "3": "Wed",
                "4": "Thu",
                "5": "Fri",
                "6": "Sat"
            }
        },
        "bulkRentalDays": {
            "preview": "{{count}} matching date (existing rental days are skipped)",
            "preview_plural": "{{count}} matching dates (existing rental days are skipped)"
        },
        "notifications": {
            "added": "Timeslot added successfully.",
            "updated": "Timeslot updated successfully.",
            "cancelled": "Timeslot cancelled successfully.",
            "uncancelled": "Timeslot cancellation removed successfully.",
            "deleted": "Timeslot deleted successfully.",
            "deleteError": "Timeslot cannot be deleted since it has bookings.",
            "exportSuccess": "Timeslots exported successfully.",
            "syncSuccess": "iCal sync completed successfully.",
            "syncError": "Failed to sync iCal. Please check the iCal URL and try again.",
            "bulkAdded": "{{created}} timeslot(s) created, {{skipped}} skipped (already exist).",
            "rentalDayCreated": "Rental day created successfully (all configured slots).",
            "rentalDayUpdated": "Rental day updated successfully.",
            "bulkRentalDaysAdded": "{{created}} rental day(s) created, {{skipped}} skipped (already exist)."
        },
        "alert": "iCal sync is enabled for this show. Please note that if you remove a timeslot, the sync may recreate it.",
        "syncButton": "Sync iCal",
        "syncing": "Syncing...",
        "syncResults": {
            "title": "iCal Sync Results",
            "created": "Created timeslots",
            "removed": "Timeslots to remove",
            "noCreated": "No new timeslots were created.",
            "noRemoved": "No timeslots need to be removed.",
            "bookingCount": "({{count}} booking)",
            "bookingCount_plural": "({{count}} bookings)",
            "warning": "These timeslots are no longer in the iCal calendar and may need to be removed manually if they have bookings."
        },
        "inlineEdit": {
            "editCapacity": "Edit capacity",
            "editNote": "Edit note",
            "booked": "booked",
            "notePlaceholder": "Add an internal note...",
            "unsavedTitle": "Unsaved changes",
            "unsavedContent": "You have unsaved changes. Do you want to discard them?",
            "discard": "Discard",
            "keepEditing": "Keep editing",
            "unlimited": "Unlimited"
        },
        "priceMatrix": {
            "title": "Custom prices",
            "info": "Set custom prices for this timeslot. Empty cells fall back to the ticket type's default price.",
            "ticketType": "Ticket type",
            "noData": "No ticket types or ticket options available for this show.",
            "noPrice": "Default"
        },
        "errors": {
            "notICalEnabled": "This show does not have iCal sync enabled.",
            "noICalUrl": "No iCal URL configured for this show.",
            "timezoneInfo": "All times are displayed in your local timezone and will be stored as-is without timezone conversion."
        },
        "assignment": {
            "title": "Seat Assignment",
            "delayedSeatSettingDisabled": "Seat selection is enabled on this show. You can still use this screen, but guests may already pick seats during booking and automatic seat assignment is active in admin.",
            "suggest": "Suggest seats",
            "sendSeatingLockEmail": "Send seating email",
            "sendingSeatingEmails": "Sending seating emails…",
            "missingSeats": "Missing seats: {{count}}",
            "unassignedGroups": "Unassigned groups",
            "allAssigned": "All bookings in this timeslot have seats assigned.",
            "clearSeats": "Clear seats",
            "noBookings": "No bookings found for this timeslot.",
            "paxAndMissing": "Pax: {{pax}} | Missing: {{missing}}",
            "requiredTicketTypes": "Needs: {{types}}",
            "bookingId": "Booking #{{id}}",
            "seatingLockEmailSent": "Seating assignment email sent.",
            "seatingLockEmailSentOn": "Seating email sent on {{-date}}",
            "resendSeatingLockEmail": "Resend seating email",
            "noCompatibleTicketType": "Selected seat does not match any unassigned ticket in this booking.",
            "seatUnavailable": "This seat is already assigned on another booking.",
            "noMissingSeats": "This booking already has seats assigned.",
            "saved": "Seat assignments saved.",
            "crossTypeMismatchTooltip": "Assigned seats do not match the expected ticket types.",
            "sendSeatingEmail": "Send seating email",
            "resendSeatingChangedEmail": "Seating changed — resend email",
            "resendSeatingEmail": "Resend seating email",
            "seatingChangedEmailSent": "Seating update email sent.",
            "arrangementSeatConflict": "This booking has a seat assigned that is not available in the selected arrangement.",
            "unassignAll": "Un-assign all",
            "unassignAllConfirmTitle": "Un-assign all seats",
            "unassignAllConfirmBody": "Remove all {{count}} seat assignments from this timeslot? This affects every booking in the manifest.",
            "unassignAllSuccess": "Cleared {{count}} seat assignments.",
            "sortByCreatedAt": "Booking date",
            "sortByBookingId": "Booking ID",
            "sortByName": "Name",
            "sortAsc": "Ascending",
            "sortDesc": "Descending",
            "tabUnassigned": "Unassigned",
            "tabAssigned": "Assigned",
            "tableUnknown": "No table",
            "splitBookingTooltip": "This booking is split across multiple tables",
            "showNotes": "Show notes",
            "hideNotes": "Hide notes"
        }
    },
    "checkinview": {
        "reopenButton": "Reopen check-in",
        "finishButton": "Finish check-in",
        "finishNote": "Finish note",
        "stats": {
            "checkedIn": "Checked In",
            "notCheckedIn": "No-Show",
            "sold": "Sold (Total)",
            "soldDescription": "Checked-in + no-show",
            "bySource": "By Booking Source",
            "source": "Source",
            "sourceDirect": "Direct",
            "byCustomerType": "By Customer Type",
            "customerType": "Customer Type",
            "email": "Email",
            "checkinNote": "Check-in Note",
            "unpaidBalance": "Unpaid Balance",
            "seated": "Seated",
            "unseated": "Unseated",
            "note": "Note",
            "manifest": "Manifest",
            "guest": "Guest",
            "tickets": "Tickets",
            "statusHeader": "Status",
            "revised": "Revised",
            "revisedDescription": "Check-in was reopened and closed again — this summary supersedes the previous one.",
            "suppressReviewEmail": "Review email suppressed"
        },
        "notifications": {
            "closed": "Check-in closed successfully.",
            "reopened": "Check-in reopened successfully.",
            "noteSaved": "Note saved successfully."
        },
        "suppressReviewEmail": "Suppress review email",
        "groupByAgeBand": "Group by age band"
    },
    "bookings": {
        "model": "Booking",
        "title": "Bookings",
        "audit": {
            "rentalDayMoved": "Rental day moved"
        },
        "summary": {
            "totalBookings": "Total Bookings",
            "totalRevenue": "Total Revenue",
            "avgRevenue": "Avg. / Booking",
            "totalPersons": "Total Persons"
        },
        "columns": {
            "bookingId": "Booking ID",
            "status": "Status",
            "venueName": "Venue name",
            "showName": "Show",
            "timeslot": "Timeslot",
            "firstName": "First name",
            "lastName": "Last name",
            "phone": "Phone",
            "email": "Email",
            "language": "Language",
            "note": "Note",
            "checkinNote": "Checkin note",
            "agentName": "Agent name",
            "commission": "Commission",
            "isCheckedIn": "Checked in",
            "confirmationCode": "Confirmation code",
            "isReviewEmailSuppressed": "Suppress review email",
            "emailNotifications": "Email notifications",
            "smsNotifications": "SMS notifications",
            "emailNotificationsDisabled": "Email notifications disabled",
            "smsNotificationsDisabled": "SMS notifications disabled",
            "guest": "Guest",
            "ticketTypes": "Ticket Types",
            "pax": "Pax",
            "source": "Source",
            "paymentMethod": "Payment Method",
            "createdAt": "Created At"
        },
        "newBooking": "New booking",
        "create": "Create",
        "sourceOnline": "Online",
        "sourceAffiliate": "Affiliate",
        "sourceCallCenter": "Call Center",
        "advancedFiltering": "Advanced Filtering",
        "clearAllFilters": "Clear all filters",
        "clearAll": "Clear All",
        "status": "Status",
        "filterLabels": {
            "id": "ID",
            "confirmationCode": "Code",
            "status": "Status",
            "search": "Search",
            "show": "Show",
            "timeslot": "Timeslot",
            "ticketType": "Ticket Type",
            "commissionGroup": "Commission Group",
            "paymentMethod": "Payment Method"
        },
        "notifications": {
            "added": "Booking added successfully.",
            "updated": "Booking updated successfully.",
            "deleted": "Booking deleted successfully.",
            "deleteError": "Booking cannot be deleted.",
            "cancelReservation": "Reservation cancelled successfully.",
            "cancelReservationError": "Reservation cannot be cancelled.",
            "exportSuccess": "Bookings exported successfully.",
            "chargeSuccess": "Invoice charged successfully."
        },
        "errors": {
            "phoneInvalid": "Phone must contain only digits, spaces, -, (, ), or +.",
            "phoneNotEmail": "Phone cannot be an email address."
        },
        "bookingDetails": "Booking #{{bookingId}}",
        "rebookedTo": "Rebooked to {{code}}",
        "rebookedFrom": "Rebooked from {{code}}",
        "rollback": {
            "timeRemaining": "Time until rollback: {{time}}",
            "overdue": "Rollback overdue — unpaid items will be released shortly"
        },
        "bookingDetailsNobooking": "No booking for this seat",
        "limitedModificationWarning": "This booking was created through an external integration. Only notes, seats, and basic contact information can be modified. Refunds and cancellations must be handled through the original booking platform.",
        "invoicedBookingWarning": "This booking is part of an affiliate invoice. Ticket modifications are not allowed.",
        "unpaidOrdersWarning": "There is an order that needs to be paid.",
        "unsavedLeaveTitle": "Unsaved changes",
        "unsavedLeaveMessage": "You have unsaved changes that will be lost. Leave this page anyway?",
        "bookingContacts": "Contact information",
        "reSource": {
            "title": "Re-source booking",
            "button": "Re-source booking",
            "success": "Booking re-sourced successfully.",
            "noCommissionGroup": "No commission group"
        },
        "resendOnContactChange": {
            "title": "Resend email?",
            "message": "The contact email changed. Resend the last email \"{{subject}}\" to {{email}}?"
        },
        "editContacts": "Edit contact",
        "saveContacts": "Save contact",
        "editAdditionalInformation": "Edit additional information",
        "saveAdditionalInformation": "Save additional information",
        "cancelBooking": "Cancel booking",
        "cancelBookingFullRefund": "Cancel booking with full refund",
        "cancelBookingWithRefund": "Cancel booking with {{refundValue}} refund",
        "cancelBookingWithNoRefund": "Cancel booking with no refund",
        "cancellationReasonLabel": "Cancellation reason",
        "overrideCancelPolicyLabel": "Override cancel policy and issue a refund",
        "overrideCancelPolicyHelp": "This booking is outside the venue's cancel window. Issuing a refund here bypasses the standard policy and is recorded in the audit log.",
        "stillBillableLabel": "Still bill this cancellation to the affiliate",
        "stillBillableReasonField": "reason",
        "stillBillableReasonPrompt": "Why should this cancelled booking stay on the affiliate invoice? (e.g. 24h-policy violation)",
        "stillBillableReasonPlaceholder": "Reason (required, up to 200 characters)",
        "contactVenue": "Contact venue",
        "contactVenueTitle": "Contact venue",
        "contactVenueMessage": "Contact the venue directly for assistance with your booking",
        "changeDate": "Change Date/Time",
        "changeDateWarning": "Changing the date/time will clear all current seat assignments. You will need to re-assign seats after the change.",
        "changePeriodLabel": "Rental period",
        "changePeriodTitle": "Convert to {{period}}",
        "changePeriodConfirm": "Convert this booking to {{period}}? This will {{impact}}. Seats will be re-assigned on save.",
        "changePeriodCharge": "charge {{amount}}",
        "changePeriodRefund": "refund {{amount}}",
        "changePeriodNoCharge": "not change the price",
        "changePeriodNoPrice": "{{types}} has no price for {{period}} - this booking cannot be converted.",
        "capacityWarning": "This booking exceeds the available capacity for: {{details}}. Saving is disabled — remove tickets or switch to another timeslot.",
        "capacityWarningOverbook": "This booking will overbook the available capacity for: {{details}}. Remaining capacity may go negative and seating must be reassigned manually. Confirm only if intended.",
        "capacityWarningDetail": "{{ticketType}} (adding {{adding}}, available {{available}})",
        "timeslotChanged": "Date/time changed",
        "autoSeatAll": "Auto-assign all seats",
        "autoSeatOne": "Auto-assign seat",
        "autoSeatFailed": "Could not auto-assign seat. No available seats found.",
        "bookingId": "Booking ID",
        "email": "Email",
        "phone": "Phone",
        "refundBookingWithAmount": "Refund booking with amount: {{refundValue}}",
        "refundBookingWithMaxAmount": "Refund booking with current maximum amount: {{refundValue}}",
        "checkinStatus": "Check-in status",
        "statusValues": {
            "processing": "Processing",
            "finished": "Finished",
            "cancelled": "Cancelled"
        },
        "searchById": "Search by booking ID",
        "searchByConfirmationCode": "Search by confirmation code",
        "importButton": "Import",
        "import": {
            "title": "Import Bookings from FareHarbor",
            "connectToFareHarbor": "Connect to FareHarbor",
            "selectShow": "Select Show",
            "fareHarborUrl": "FareHarbor URL",
            "email": "Email",
            "password": "Password",
            "connect": "Connect & Fetch Data",
            "mapItems": "Map FareHarbor Items to Show Items",
            "fareHarborVendor": "Vendor",
            "fareHarborProduct": "Product",
            "fareHarborTicket": "Ticket",
            "mapTo": "Map To",
            "doNotImport": "Do not import",
            "startImport": "Start Import",
            "dryRun": "Dry run (validate only, do not import)",
            "createMissingTimeslots": "Create missing timeslots",
            "progress": "Import Progress",
            "progressText": "Processed {{finished}} of {{total}} vouchers ({{imported}} imported successfully)",
            "errorsTitle": "{{count}} error(s) occurred during import",
            "connectionSuccess": "Connected to FareHarbor successfully",
            "importSuccess": "Successfully imported {{count}} booking(s)",
            "importCompletedWithErrors": "Import completed with {{imported}} booking(s) imported and {{errors}} error(s)",
            "errors": {
                "fillAllFields": "Please fill in all fields",
                "connectionFailed": "Connection to FareHarbor failed",
                "importFailed": "Import failed"
            }
        },
        "massAction": {
            "button": "Mass Cancel / Refund",
            "modalTitle": "Bulk Action for {{count}} Bookings",
            "warning": "ATTENTION - Validate guest name and activity details before executing.",
            "selectedCount": "Selected: {{count}}",
            "clearSelection": "Clear Selection",
            "selectAllMatchingFilters": "Select all bookings matching current filters (all pages)",
            "selectAllHint": "Info: Selecting the header checkbox includes matching bookings from every page, not only the current page.",
            "selectingAllPages": "Selecting all matching bookings across all pages...",
            "selectAllError": "Failed to select all matching bookings.",
            "noOperableBookings": "No cancellable or refundable bookings match the current filters.",
            "noSelection": "No bookings selected.",
            "operationType": "Operation Type",
            "cancelAndRefund": "Cancel Booking (with refund)",
            "cancelWithoutRefund": "Cancel Booking (without refund)",
            "refundOnly": "Refund Only",
            "operationHintCancelAndRefund": "Cancels the selected bookings and creates a refund based on the selected refund calculation.",
            "operationHintCancelWithoutRefund": "Cancels the selected bookings without issuing any refund.",
            "operationHintRefundOnly": "Keeps bookings active and issues refunds based on the selected refund calculation.",
            "refundCalculation": "Refund Calculation",
            "refundFull": "Full Refund (100%)",
            "refundPercentage": "Percentage (%)",
            "refundFixed": "Fixed Amount ($)",
            "percentageInputLabel": "Refund Percentage (%)",
            "fixedInputLabel": "Fixed Refund Amount",
            "executeButton": "Execute",
            "runningProgress": "Processing...",
            "resultTitle": "Results",
            "progressLabel": "{{completed}} / {{total}} complete ({{percent}}%)",
            "resultSuccess": "Operation completed successfully.",
            "resultFailed": "Operation failed.",
            "statusSuccess": "Success",
            "statusFailed": "Failed",
            "completedSuccess": "Mass operation completed successfully for {{count}} bookings.",
            "completedWithFailures": "Mass operation completed with {{failureCount}} failures.",
            "invalidRefundAmount": "Refund amount must be greater than 0.",
            "maxRefundableTotal": "Max refundable (total):",
            "plannedRefundTotal": "Planned refund (total):",
            "gridHeaderId": "ID",
            "gridHeaderBooker": "Booker",
            "gridHeaderPlanned": "Planned",
            "gridHeaderMax": "Max"
        },
        "addBooking": "Add Booking"
    },
    "crm": {
        "title": "Customers",
        "searchPlaceholder": "Search by name, email or phone…",
        "viewBooking": "View booking",
        "bookings": "Bookings",
        "bookingsCount": "{{count}} booking(s)",
        "noBookings": "No bookings to show.",
        "unknownName": "Unknown",
        "columns": {
            "name": "Name",
            "email": "Email",
            "phone": "Phone",
            "bookingCount": "Bookings",
            "lastBooking": "Last booking"
        }
    },
    "bookingitems": {
        "model": "Booking item (ticket)",
        "title": "Reservation",
        "paxSummary": "{{count}} PAX: {{breakdown}}",
        "cateringview": "Catering view",
        "checkinview": "Check-in view",
        "booker": "Booker",
        "columns": {
            "quantity": "Quantity",
            "ticketOptionName": "Ticket option",
            "ticketTypeName": "Ticket type",
            "ticketSeatName": "Seat",
            "ticketCount": "Tickets",
            "price": "Price",
            "note": "Note",
            "checkinNote": "Checkin note",
            "showTitle": "Show title",
            "originalPrice": "Original price : {{price}}",
            "priceWithTaxAndFees": "With tax and fees"
        },
        "notifications": {
            "checkinNote": {
                "updated": "Checkin note updated successfully."
            },
            "exportSuccess": "Booking items exported successfully."
        },
        "netPriceDescription": "Net price is {{price}}, taxes and fees are not included.",
        "noBookingForThisSeat": "No booking for this seat with these filters",
        "modifyTickets": {
            "title": "Modify tickets",
            "description": "Please doublecheck the list on what is being modified. You should confirm the changes by clicking the 'Yes' button.",
            "priceChange": "Booking price changed from {{oldPrice}} to {{newPrice}}, this will result in a new order being created. The final price including taxes and fees is {{newFinalPriceSum}}, which was {{oldFinalPriceSum}}.",
            "priceChangeNetRate": "Booking price changed from {{oldFinalPriceSum}} to {{newFinalPriceSum}}, this will result in a new order being created. Net-rate bookings are charged retail minus commission; taxes and fees are not applied.",
            "noChangesTitle": "No changes made",
            "noChangesContent": "Please confirm that you did not make any changes to the booking items.",
            "error": "Error while modifying tickets: {{error}}",
            "success": "Tickets modified successfully.",
            "sendNotification": "Send notification to the user"
        },
        "editSeats": "Edit seats",
        "saveSeats": "Save seats",
        "unsavedChanges": "Unsaved changes",
        "cancelEdit": "Cancel editing",
        "saveBlockedByCapacity": "Cannot save — exceeds available capacity. Overbook permission required.",
        "warningPendingOrders": "Pending orders",
        "discardPendingTitle": "Discard pending modification and edit",
        "discardPendingMessage": "This booking has a pending modification awaiting payment. Discard it to edit the booking again.",
        "discardPendingWarning": "Held tickets will be released. Your previous changes are reloaded into the editor so you can refine them before saving.",
        "simplified": {
            "addTickets": "Add Tickets",
            "currentTickets": "Current Tickets",
            "noTickets": "No tickets yet",
            "autoSeatingOnSave": "Seats will be automatically assigned when you save",
            "seatsAssignedLater": "Seats will be assigned later",
            "switchToSimplified": "Switch to simplified view",
            "switchToDetailed": "Switch to detailed view",
            "addToTable": "Add to table",
            "removeFromTable": "Remove from table",
            "dynamicPriceHint": "Dynamic price. Base {{base}}."
        },
        "validation": {
            "seatNotCompatible": "Seat is not compatible with selected ticket type",
            "invalidCombination": "This ticket option cannot be sold with the selected ticket type",
            "priceDifference": "Price differs from suggested price ({{price}})"
        },
        "seated": "Seated",
        "unseated": "Not seated"
    },
    "bookingstatus": {
        "processing": "Processing",
        "finished": "Finished",
        "cancelled": "Cancelled"
    },
    "orderstatus": {
        "pending": "Pending",
        "refunding": "Refunding",
        "settled": "Settled",
        "rollback": "Rollback",
        "refunded": "Refunded"
    },
    "orders": {
        "model": "Order",
        "title": "Orders",
        "titleWithTickets": "Orders & tickets",
        "ticketTotal": "{{total}} total",
        "notPayable": "This order is no longer payable.",
        "columns": {
            "id": "ID",
            "status": "Status",
            "amount": "Amount",
            "createdAt": "Created at",
            "rollbackTimeAt": "Rollback time at"
        },
        "notifications": {
            "added": "Order added successfully.",
            "updated": "Order updated successfully.",
            "deleted": "Order deleted successfully.",
            "deleteError": "Order cannot be deleted.",
            "rollbacked": "Order rolled back successfully.",
            "rollbackError": "Order cannot be rolled back.",
            "moreTimeAdded": "More time added successfully.",
            "moreTimeError": "More time cannot be added.",
            "rollbackTimeSet": "Rollback time updated successfully."
        },
        "addMoreTime": "Add more rollback time",
        "customRollbackModal": {
            "title": "Set Custom Rollback Time",
            "nowLabel": "Current time (HST)",
            "targetLabel": "Target rollback time",
            "fromNow": "from now",
            "ago": "ago",
            "afterCurrent": "after current rollback",
            "beforeCurrent": "before current rollback"
        }
    },
    "transactions": {
        "title": "Transactions",
        "columns": {
            "id": "ID",
            "showName": "Show name",
            "startTime": "Start time",
            "booker": "Booker",
            "finished": "Finished",
            "amount": "Amount",
            "paymentInfo": "Payment info",
            "createdAt": "Created at",
            "payment_type": "Payment type",
            "refund_note": "Refund note",
            "finishedBy": "Finished by",
            "processing_fee": "Processing Fee",
            "total": "Total"
        },
        "showOnlyUnfinished": "Only unfinished",
        "showOnlyFinished": "Only finished",
        "fee": "fee",
        "status": {
            "completed": "Completed",
            "processing": "Processing"
        },
        "processingFeeDescription": "Additional fee charged by payment method",
        "totalProcessingFees": "Total Processing Fees",
        "processingFeeRefund": "Processing fees will be refunded for full cancellations only",
        "noteSaved": "Note saved successfully.",
        "editNote": "Edit Note",
        "editNoteTitle": "Edit Transaction Note",
        "noteLabel": "Note",
        "changePaymentType": {
            "title": "Change payment type",
            "button": "Change payment type",
            "label": "Payment type",
            "help": "Switch to another cash payment type with the same processing fee.",
            "success": "Payment type changed successfully."
        },
        "processingFeeSaved": "Processing fee saved.",
        "editProcessingFee": "Edit processing fee",
        "editProcessingFeeTitle": "Edit processing fee",
        "processingFeeLabel": "Processing fee ($)"
    },
    "manualrefunds": {
        "title": "Manual Refunds",
        "no_transactions": "No cash transactions requiring manual refunds found.",
        "do_refund": "Do Refund",
        "already_refunded": "Already Refunded",
        "modal_title": "Confirm Manual Refund",
        "transaction_details": "Transaction Details",
        "modal_warning": "This action will mark the cash transaction as manually refunded. Please ensure the refund has been processed outside the system before confirming.",
        "note_label": "Refund Note",
        "note_placeholder": "Enter details about how the refund was processed...",
        "confirm_refund": "Confirm Refund",
        "refund_success": "Manual refund marked as complete successfully.",
        "refund_error": "Failed to mark refund as complete. Please try again."
    },
    "emaillogs": {
        "title": "Email logs",
        "model": "Email log",
        "unknownLogType": "Unknown log type",
        "columns": {
            "userName": "User name",
            "to": "To",
            "subject": "Subject",
            "result": "Result",
            "content": "Content",
            "created": "Created",
            "type": "Type"
        },
        "resendEmail": "Resend email",
        "emailHasBeenSentAgain": "Email has been sent again!",
        "areYouSureResend": "Are you sure you want to resend this email?",
        "viewEmail": "View email",
        "mail": "Email",
        "modal": {
            "date": "Date",
            "from": "From",
            "to": "To",
            "subject": "Subject",
            "result": "Result",
            "sender": "Sender"
        },
        "emailTester": "Email template tester",
        "emailTesterTemplate": "Template",
        "emailTesterVariant": "Variant",
        "emailTesterVariantDefault": "Default",
        "emailTesterLanguage": "Language",
        "emailTesterSelectTemplate": "Select a template to preview",
        "emailTesterDesktop": "Desktop view",
        "emailTesterMobile": "Mobile view"
    },
    "paymentmethods": {
        "model": "Payment method",
        "title": "Payment methods",
        "columns": {
            "id": "ID",
            "venueName": "Venue name",
            "slug": "Slug",
            "name": "Name",
            "methodType": "Method type",
            "agentOnly": "Agent only",
            "noteRequired": "Note required",
            "percentage": "Percentage (%)",
            "usd": "Fixed Fee (USD)",
            "enabled": "Enabled"
        },
        "newPaymentMethodTitle": "New payment method",
        "notifications": {
            "added": "Payment method added successfully.",
            "updated": "Payment method updated successfully.",
            "deleted": "Payment method deleted successfully.",
            "toggled": "Payment method toggled successfully.",
            "deleteError": "Payment method cannot be deleted.",
            "toggleError": "Payment method cannot be toggled."
        },
        "methodTypes": {
            "card": "card: Pay via Card",
            "cash": "cash: Via Cash",
            "net_rate": "net_rate: Net Rate (guest pays net price)",
            "net_rate_company": "net_rate_company: Net Rate (company card charged net)"
        },
        "netRateCompanyInfo": "The commission group's saved company card will be charged for the net amount (retail price minus commission). The agent collects full retail from the customer externally.",
        "paymentBlock": "Payment block"
    },
    "refundChunks": {
        "title": "Refund chunks",
        "columns": {
            "name": "Name",
            "max": "Max amount",
            "method": "Method",
            "info": "Info",
            "note": "Note",
            "status": "Status",
            "refundStatus": "Refund status",
            "statusValues": {
                "pending": "Pending",
                "refunded": "Refunded"
            }
        },
        "refundAmount": "Refund amount",
        "refundButton": "Refund"
    },
    "refundModal": {
        "title": "Refund reservation",
        "content": "Please enter the amount you want to refund for this reservation."
    },
    "widgetInformations": {
        "description": "Description",
        "hours": "Hours",
        "reviewer": "Reviewer",
        "reviewers": "Reviewers",
        "paymentDeadlineExpires": "Payment deadline expires",
        "paymentExpiredTitle": "Payment expired",
        "paymentExpired": "The payment deadline has expired, and your current reservation is no longer valid. Please restart the booking process.",
        "restartBooking": "Restart booking",
        "pricesFor": "Prices for",
        "pricesForSelectedDateAndTime": "Prices for selected date and time"
    },
    "widgetStepNavigation": {
        "step1next": "Start booking",
        "step2back": "Choose a different date or time",
        "step2next": "Pick seats",
        "step3back": "Change tickets",
        "step3next": "Booking information",
        "step4back": "Change booking information",
        "step4next": "Reserve tickets",
        "step5back": "Booking",
        "step5retry": "Retry reservation"
    },
    "widgetSidebarSteps": {
        "datetime": "Date and time",
        "tickets": "Tickets",
        "seats": "Seats",
        "bookingInformation": "Booking information"
    },
    "widgetDatePicker": {
        "multipleEventsOnSameDay": "Start time:",
        "emptyOption": "Time not selected",
        "selectedTimeslot": "Start time:",
        "nextMonth": "Next month",
        "prevMonth": "Previous month",
        "selectMonth": "Select month",
        "prevYear": "Previous year",
        "nextYear": "Next year",
        "dateAndTime": "Date and time",
        "selectPeriod": "Select rental slot:"
    },
    "widgetLocale": "en-US",
    "widgetFooter": {
        "notice": "All prices are in US dollars.",
        "poweredBy": "Powered by",
        "poweredByLink": "https://www.fire-knife.com/"
    },
    "widgetInfo": {
        "selectTickets": "Select tickets",
        "totalPrice": "Total price:",
        "selectYourSeats": "Select your seats",
        "selectedSeats": "Selected seats:",
        "noSeatingForThisTicket": "No seating for this ticket",
        "suggestedSeats": "Suggested seats",
        "acceptSuggestedSeats": "Accept suggested seats",
        "clearSeats": "Clear seats",
        "invalidSuggestion": "Not enough seats available",
        "suggested": "Suggested",
        "noSeatingRequired": "No seat selection required",
        "seatsAssignedBeforeEvent": "Seats will be assigned before the event",
        "switchTicketType": "Switch"
    },
    "widgetBookingSummary": {
        "cancellationPolicy": "Cancellation policy",
        "needToKnow": "Need to know",
        "bookingSummaryTitle": "Booking summary",
        "tableColumns": {
            "quantity": "Qty",
            "name": "Ticket name (SKU)",
            "pricePerItem": "Price per item",
            "totalCost": "Total Cost"
        },
        "taxes": "Taxes",
        "fees": "Fees",
        "fee": "fee",
        "tax": "tax",
        "subtotal": "Subtotal",
        "subtotalNet": "Subtotal (Net)",
        "totalFees": "Total Fees",
        "totalTaxes": "Total Taxes",
        "total": "Total",
        "grandTotal": "Grand Total",
        "bookingTotal": "Booking total",
        "bookingFee": "Booking fee",
        "bookingFeeInfo": "Booking fee information",
        "bookingFeeInfoText": "The booking fee includes applicable taxes and fees.",
        "ticketTypeLabel": "Ticket type",
        "seatLabel": "Seat",
        "pendingRemoved": "Once the payment is completed, this item will be removed from the booking.",
        "pendingAdd": "Once the payment is completed, this item will be finalized.",
        "otherFees": "Other fees"
    },
    "widgetBookingInformation": {
        "contactInformation": "Contact information",
        "firstName": "First name",
        "lastName": "Last name",
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "emailError": "Invalid email format, please check your email address.",
        "phoneError": "Please enter a valid phone number (digits, spaces, -, (, ), or +).",
        "smsNotificationInfo": "If you set, we will send you an SMS notification about your booking.",
        "seatingGroupCheckbox": "I'd like to be seated with my friends",
        "seatingGroupDescription": "Our team will do their best to seat your group together. Leave a note below so we can match your booking to theirs — the more detail, the better.",
        "seatingGroupNoteLabel": "Who are you sitting with?",
        "seatingGroupNotePlaceholder": "e.g. John Smith, booking code #1234, or 'Smith family'",
        "seatingGroupNoteRequired": "Please add a note so we can identify your group"
    },
    "widgetWaitlist": {
        "changeTickets": "Change tickets",
        "unavailableTitle": "Unavailable for booking",
        "selectedTicketsStatus": "Selected tickets status",
        "joinTitle": "Join the waitlist",
        "joinDescription": "Leave your details below and we'll contact you if seats become available for your selected tickets.",
        "statusAvailable": "Available",
        "statusSoldOut": "Sold Out",
        "joinButton": "Join waitlist",
        "noPaymentRequired": "Waitlist request only.\nNo payment is required now.",
        "bookingSummaryTitle": "Booking Summary",
        "waitlistLabel": "Waitlist",
        "waitlistAvailable": "Waitlist available",
        "requestSubmitted": "Request submitted",
        "contactLabel": "Contact",
        "contactConfirmed": "Confirmed",
        "waitlistStatusLabel": "Waitlist Status:",
        "pendingAvailability": "Pending Availability",
        "noPaymentProcessed": "No payment was processed for waitlisted items.",
        "successTitle": "You're on the waitlist!",
        "successDescriptionRich": "We've received your request for <strong>{{tickets}}</strong> tickets for <strong>{{date}}</strong>. We'll notify you at <email>{{email}}</email> as soon as seats become available.",
        "returnHome": "Return to home"
    },
    "upgrades": {
        "pageTitle": "Upgrades",
        "sendingOffers": "Sending offers...",
        "selectShowAndTimeslot": "Select a show and timeslot to view upgrade offers",
        "empty": "No upgrade offers available",
        "emptyFiltered": "No upgrade offers match the current filters",
        "upgradePaths": "Upgrade Paths",
        "fromTicketType": "From Ticket Type",
        "toTicketType": "To Ticket Type",
        "addPath": "Add Path",
        "removePath": "Remove Path",
        "pathAdded": "Upgrade path added",
        "pathRemoved": "Upgrade path removed",
        "notify": {
            "offerSent": "Upgrade offer sent",
            "reminderSent": "Reminder sent",
            "dismissed": "Offer dismissed",
            "bulkSent": "{{count}} offer(s) sent",
            "bulkSkipped": "{{count}} offer(s) skipped",
            "bulkFailed": "{{count}} offer(s) failed"
        },
        "actions": {
            "sendOffer": "Send Offer",
            "sendBulkOffer": "Send Bulk Offer",
            "sendReminder": "Send Reminder",
            "dismiss": "Dismiss",
            "dismissBookingConfirm": "Are you sure you want to dismiss this booking from upgrade eligibility?",
            "dismissOfferConfirm": "Are you sure you want to dismiss this upgrade offer? This will trigger a rollback.",
            "applyUpgrade": "Apply Upgrade"
        },
        "errors": {
            "priceUnavailable": "Could not apply the upgrade automatically - the target ticket price is unavailable. Please adjust the booking manually."
        },
        "columns": {
            "guest": "Guest",
            "group": "Group",
            "upgradeTo": "Upgrade To",
            "priceDifference": "Price Difference",
            "status": "Status",
            "activity": "Activity",
            "actions": "Actions"
        },
        "status": {
            "eligible": "Eligible",
            "sent": "Sent",
            "settled": "Settled",
            "expired": "Expired",
            "declined": "Declined",
            "neverNotified": "Never Notified"
        },
        "filters": {
            "show": "Show",
            "timeslot": "Timeslot",
            "search": "Search",
            "searchPlaceholder": "Search by name, email or confirmation code",
            "eligibleOnly": "Eligible only",
            "neverNotifiedOnly": "Never notified only"
        },
        "activity": {
            "lastNotified": "Last notified",
            "sentTimes": "Sent {{count}} time(s)"
        },
        "labels": {
            "noPhone": "No phone"
        }
    },
    "widgetReservationInfo": {
        "title": "Reservation information",
        "startTime": "Start time",
        "reservationId": "Reservation ID",
        "contactInformation": "Contact information",
        "contactInformationAndOtherData": "Contact information and other data",
        "status": "Status",
        "payment": "Payment",
        "statusValues": {
            "processing": "Processing",
            "finished": "Finished",
            "cancelled": "Cancelled",
            "pending": "Pending"
        },
        "orders": {
            "title": "Orders",
            "orderId": "ID",
            "amount": "Amount",
            "status": "Status",
            "createdAt": "Created at",
            "rollbackTimeAt": "Rollback time at",
            "statusValues": {
                "pending": "Pending",
                "refunding": "Refunding",
                "settled": "Settled",
                "rollback": "Rollback",
                "refunded": "Refunded"
            }
        },
        "transaction": {
            "statusValues": {
                "finished": "Finished",
                "inprogress": "In progress",
                "pending": "Pending"
            },
            "amount": "Amount",
            "transactionId": "Transaction ID",
            "status": "Status",
            "paymentMethod": "Payment method",
            "date": "Date",
            "discountReversalLabel": "Discount reversal"
        },
        "paymentMethods": {
            "title": "Payment methods",
            "amountLabel": "Will pay in this transaction:",
            "note": "Note"
        },
        "card": {
            "oldCard": "Card ending in {{cardLast4}} with expiration date {{expMonth}}/{{expYear}}",
            "newCard": "Register a new card"
        },
        "notes": "Notes",
        "payButton": "Pay",
        "refundChunks": {
            "title": "Refund chunks",
            "name": "Name",
            "max": "Max amount",
            "method": "Method",
            "info": "Info",
            "note": "Note",
            "status": "Status",
            "refundStatus": "Refund status",
            "statusValues": {
                "pending": "Pending",
                "refunded": "Refunded"
            },
            "refundAmount": "Refund amount",
            "refundButton": "Refund",
            "invalidAmount": "Invalid refund amount",
            "fullRefundRequired": "You must distribute the full refund amount ({{amount}}) across all available payment methods.",
            "couponContactAgent": "This booking includes a coupon, so a refund cannot be processed from this page. Please contact the venue to request a refund.",
            "contactVenueButton": "Contact venue"
        },
        "paymentDetails": {
            "oneTimePayment": "One-time payment",
            "splitPayment": "Split payment",
            "single": "Single",
            "split": "Split",
            "payableAmount": "Payable amount:",
            "processingFee": "Processing Fee",
            "processingFeeDisclaimer": "Foreign cards and splits may be subject to additional fees.",
            "totalCharge": "Total Charge",
            "processingFeeWillBeIncluded": "Processing fee will be included in the total charge. The processing fee is: {{fee}}",
            "includesProcessingFee": "Includes {{fee}} processing fee",
            "wantToSplit": "Want to split this payment?",
            "remainingNotice": "The remaining {{amount}} will need to be paid in a subsequent transaction.",
            "paymentXofY": "Payment {{current}} of {{max}}",
            "unlimitedSplitPayments": "Unlimited split payments allowed"
        }
    },
    "image": {
        "upload": "Upload image",
        "remove": "Remove image",
        "uploading": "Uploading image(s), please wait...",
        "add": "Add image",
        "image": "Image",
        "imageUrl": "Image URL",
        "imageUrlPlaceholder": "https://example.com/image.jpg",
        "imageUploadError": "Error uploading image",
        "uploadStarted": "Upload started for image",
        "uploadFinished": "Upload finished for image",
        "imageViewer": "Image viewer",
        "previousImage": "Previous image",
        "nextImage": "Next image",
        "closeGallery": "Close gallery"
    },
    "richtext": {
        "linkDescription": "Enter the URL and the text you want to display for the link. The link will open in a new tab.",
        "imageDescription": "Upload an image or enter the image URL. The image will be displayed full width in the content.",
        "linkTextPlaceholder": "Text to display",
        "displayAsButton": "Display as button"
    },
    "onboarding": {
        "title": "Onboarding",
        "description": "In order to use the widget on your website, you need to add the following code snippet before the closing </body> tag of your website.",
        "way1": "You can trigger the booking modal by calling the following javascript function (please note, that 1234 is the show ID):",
        "way2": "You can also use the following HTML code snippet to embed a booking button on your website (please note, that 1234 is the show ID):",
        "way3": "Each show has a unique widget slug, so it's super important to use the proper identifier for the modal or button. Here are the shows and their code:",
        "showName": "Show name",
        "showCall": "Show call",
        "directSite": "Direct site",
        "showId": "Show ID",
        "bookNow": "Book Now"
    },
    "emails": {
        "subjects": {
            "iCalSyncTimeslotsUpdated": "ICal Sync - Timeslots Updated",
            "completeYourReservation": "Complete Your Reservation - Don't Miss Out!",
            "showReminderTomorrow": "Reminder: {{showTitle}} tomorrow!",
            "reviewExperience": "How was your experience at {{showTitle}}?",
            "refundsRequiringAttention": "Refunds requiring attention",
            "refundProcessed": "Refund Processed",
            "welcomeToFireknife": "Welcome to Fireknife! Log in to Get Started",
            "passwordReset": "Fireknife - Password reset",
            "bookingUpdated": "Booking Updated",
            "bookingCancelled": "Booking Cancelled",
            "bookingCancelledFullRefund": "Booking Cancelled - Full Refund",
            "paymentRequired": "Payment Required",
            "reservationConfirmed": "Your reservation has been confirmed",
            "abandonedCart": "Complete Your Reservation - Don't Miss Out!",
            "adminRefundNotification": "Refunds requiring attention",
            "waitlistTicketsAvailable": "Tickets available for {{showTitle}}",
            "waitlistSeatsAvailable": "Waitlist entries now fulfillable",
            "affiliateInvoiceDispatch": "Affiliate invoice {{-showDateFrom}} - {{-showDateTo}}",
            "bookingDateChanged": "Your Booking Date Has Changed",
            "upgradeOffer": "Upgrade Available for Your Booking",
            "checkinClosed": "Check-in Closed - Summary",
            "upgradeEligibleNotify": "Bookings available for upgrade"
        },
        "messages": {
            "passwordResetSent": "Password reset sent!",
            "passwordResetEmailSent": "Password reset email sent!",
            "inviteFails": "Failed to send invite email. Please check the email address and try again.",
            "passwordResetFails": "Password reset failed. Please try again later.",
            "cancelFails": "Failed to send cancellation email for booking.",
            "paymentNeededFails": "Failed to send payment needed email for booking.",
            "refundConfirmationFails": "Failed to send refund confirmation email for booking.",
            "waitlistReminderFails": "Failed to send waitlist reminder email."
        }
    },
    "svgeditor": {
        "chair": "Chair",
        "table": "Table",
        "table2": "Table 2",
        "table3": "Table 3",
        "table4": "Table 4",
        "table5": "Table 5",
        "table6": "Table 6",
        "stage": "Stage",
        "fitToFloorplan": "Fit to floorplan",
        "zoomIn": "Zoom In",
        "zoomOut": "Zoom Out"
    },
    "payment": {
        "paymentStarted": "Payment started, please check the transaction's status in a moment.",
        "paymentXofY": "Payment {{current}} of {{max}}",
        "unlimitedSplitPayments": "Unlimited split payments allowed"
    },
    "formik": {
        "showPassword": "Show password",
        "hidePassword": "Hide password"
    },
    "email": {
        "abandoned_cart": {
            "title": "Don't miss out on your reservation!",
            "body1": "Some awesome event is waiting for you! We noticed that you left some items in your cart without completing the booking.<br/><br/>Don't worry, your cart is still saved, but <b>hurry up</b> to complete your booking before the items are gone!",
            "ticketsTitle": "Tickets",
            "buttonLabel": "Complete reservation"
        },
        "admin_refund_notify": {
            "title": "Cancel within window",
            "body1": "There were some bookings that were cancelled within the cancellation window, if any guest requests a refund, feel free to refund them.",
            "guestHeader": "Guest",
            "bookingHeader": "Booking",
            "buttonLabel": "Show booking"
        },
        "booking_update_notify": {
            "title": "Booking Updated",
            "subtitle": "Update notification from agent",
            "body1": "Your booking has been updated by our team. Here are the details:",
            "messageFrom": "Message from {{agentName}}:",
            "buttonLabel": "Manage reservation",
            "summaryTitle": "Updated reservation summary",
            "dateChangedTitle": "Date & Time Changed",
            "previousDateLabel": "Previous:",
            "newDateLabel": "New:"
        },
        "cancel_full_refund": {
            "title": "Booking Cancelled - Full Refund",
            "subtitle": "Your booking for {{showName}} has been cancelled",
            "body1": "Your booking has been successfully cancelled and you will receive a full refund.",
            "cancellationReasonLabel": "Cancellation reason:",
            "refundAmountLabel": "Refund amount:",
            "refundMethodLabel": "Refund method:",
            "refundTimeframeLabel": "Expected refund time:",
            "cancelledStatus": "CANCELLED",
            "summaryTitle": "Cancelled booking summary",
            "contactUsTitle": "Contact us",
            "contactUsBody": "If you have any questions about your cancellation or refund, please contact us:"
        },
        "cancel_inside_window": {
            "title": "Booking Cancelled",
            "subtitle": "Your booking for {{showName}} has been cancelled",
            "body1": "Your booking has been cancelled within the cancellation window.",
            "cancellationReasonLabel": "Cancellation reason:",
            "cancellationPolicyLabel": "Cancellation policy:",
            "refundAmountLabel": "Refund amount:",
            "refundMethodLabel": "Refund method:",
            "refundTimeframeLabel": "Expected refund time:",
            "noRefund": "Refund: No refund available due to cancellation timing.",
            "cancelledStatus": "CANCELLED",
            "summaryTitle": "Cancelled booking summary",
            "contactUsTitle": "Contact us",
            "contactUsBody": "If you have any questions about your cancellation, please contact us:"
        },
        "cancel_partial_refund": {
            "title": "Booking Cancelled",
            "subtitle": "Your booking for {{showName}} has been cancelled",
            "body1": "Your booking has been cancelled with a partial refund.",
            "cancellationReasonLabel": "Cancellation reason:",
            "cancellationPolicyLabel": "Cancellation policy:",
            "refundAmountLabel": "Refund amount:",
            "refundMethodLabel": "Refund method:",
            "refundTimeframeLabel": "Expected refund time:",
            "noRefund": "No refund was issued for this cancellation.",
            "cancelledStatus": "CANCELLED",
            "summaryTitle": "Cancelled booking summary",
            "contactUsTitle": "Contact us",
            "contactUsBody": "If you have any questions about your cancellation, please contact us:"
        },
        "delete_timeslot": {
            "title": "iCal sync result",
            "body1": "For <b>{{showName}}</b> we did sync the iCal calendar with the following result.",
            "createdTimeslotsTitle": "Created timeslots",
            "noNewTimeslots": "No new timeslots were created.",
            "removedTimeslotsTitle": "Should be removed",
            "noRemovedTimeslots": "No timeslots need to be removed.",
            "bookingCount": "({{count}} bookings)",
            "removedTimeslotsInfo": "These timeslots are no longer available in the iCal calendar and should be removed from the system. This is not done automatically, since there might be bookings for these timeslots."
        },
        "existinguserinvite": {
            "greeting": "Hi {{name}},",
            "body1": "You have been prompted to log in to {{venue}}'s venue. Please click on the button below to navigate to the platform.",
            "buttonLabel": "Click here to log in."
        },
        "invite": {
            "greeting": "Hi {{name}},",
            "body1": "You have been invited to {{venue}}'s Fireknife platform. Please click on the button below to create your password.",
            "commissionGroupContext": "You have been added to the commission group \"{{groupName}}\".",
            "showContext": "This group is associated with the show: {{showTitle}}.",
            "buttonLabel": "Click here to create a new password."
        },
        "affiliatetools": {
            "title": "Your affiliate booking link",
            "body1": "Bookings made through the link below are automatically credited to you. You can add your own UTM parameters to it to track your own campaigns.",
            "codeLabel": "Your affiliate code:",
            "linkLabel": "Your booking link:"
        },
        "payment_needed": {
            "title": "Payment Required",
            "subtitle": "Complete your booking for {{showName}}",
            "body1": "Your reservation is almost complete! We need payment to secure your booking.",
            "paymentDueByLabel": "Payment due by:",
            "buttonLabel": "Complete payment",
            "summaryTitle": "Booking summary"
        },
        "waitlist_reminder": {
            "title": "Great news, tickets are available",
            "subtitle": "Your requested tickets for {{showName}} can be booked now",
            "body1": "Hi {{subscriberName}}, the full ticket combination you asked for is currently available. Tap below to continue booking.",
            "buttonLabel": "Book now",
            "summaryTitle": "Requested tickets"
        },
        "upgrade_offer": {
            "title": "Upgrade Available",
            "greeting": "Hi {{name}},",
            "vipAvailable": "We have a limited-time upgrade available for your booking on {{date}}. Review the details below and confirm if you'd like to secure it.",
            "currentTicketsTitle": "Tickets to upgrade",
            "upgradeTicketsTitle": "After upgrade",
            "priceDifference": "Price difference:",
            "deadline": "Offer expires:",
            "payNow": "Accept upgrade"
        },
        "waitlist_seats_available": {
            "title": "Waitlist entries now fulfillable",
            "intro": "{{count}} waitlist subscriber(s) across {{timeslotCount}} timeslot(s) can now be seated.",
            "andMore": "…and {{count}} more",
            "buttonLabel": "Open waitlist",
            "ticketsCount": "{{count}} ticket(s)"
        },
        "post_show_review": {
            "title": "Thanks for attending {{showName}}!",
            "buttonLabel": "Leave a review"
        },
        "pwreset": {
            "greeting": "Hi {{name}},",
            "body1": "Your password has been reset. Click on the button below to reset your password.",
            "buttonLabel": "Click here to create a new password."
        },
        "refund_confirmation": {
            "title": "Refund Processed",
            "subtitle": "Your refund has been processed",
            "body1": "You have received a refund for your booking. Based on the payment method, it might take extra steps or time for the refund to appear in your account.",
            "totalRefundAmountLabel": "Total refund amount:",
            "processingFeeReturnedLabel": "Processing fee returned:",
            "refundBreakdownLabel": "Refund breakdown:",
            "refundChunkLabel": "Refund {{index}}:",
            "amountLabel": "Amount:",
            "methodLabel": "Method:",
            "discountReversalLabel": "Type:",
            "discountReversalValue": "Discount reversal (no money moves)",
            "transactionIdLabel": "Transaction ID:",
            "timeframeLabel": "Expected processing time:",
            "refundReasonLabel": "Refund reason:",
            "refundAmountLabel": "Refund amount:",
            "refundMethodLabel": "Refund method:",
            "refundProcessedStatus": "REFUND PROCESSED",
            "summaryTitle": "Refunded booking summary",
            "contactUsTitle": "Contact us",
            "contactUsBody": "If you have any questions about your refund, please contact us:"
        },
        "checkinLabel": "Check-in:",
        "showStartsLabel": "Show starts:",
        "checkinAndShowStartsLabel": "Check-in & show start:",
        "reservation_created": {
            "title": "We got your reservation!",
            "subtitle": "Message from {{venueName}}",
            "buttonLabel": "Manage reservation",
            "cancellationPolicyTitle": "Cancellation policy",
            "needToKnowTitle": "Need to know",
            "summaryTitle": "Reservation summary"
        },
        "show_reminder": {
            "title": "See you soon!",
            "subtitle": "Tomorrow at {{venueName}}",
            "buttonLabel": "Manage reservation",
            "cancellationPolicyTitle": "Cancellation policy",
            "needToKnowTitle": "Need to know",
            "summaryTitle": "Reservation summary",
            "checkInTimeLabel": "Check-in time",
            "tableAssignmentLabel": "Table assignment"
        },
        "seating_locked": {
            "subject": "Your seating has changed for {{showTitle}}",
            "title": "Your seating assignment has been updated",
            "reminderMessage": "Your seating assignment has been updated. Please review your new table assignment and check-in time below.",
            "checkInTimeLabel": "Check-in time",
            "assignmentLabel": "Table assignment",
            "assignmentLabelTable": "Table assignment",
            "assignmentLabelSeat": "Seat assignment",
            "buttonLabel": "View reservation",
            "summaryTitle": "Reservation summary"
        },
        "seating_locked_manifest_copy": {
            "subject": "Seating manifest: {{showTitle}}",
            "intro": "Seating assignments were just emailed to guests. Below is the current check-in manifest.",
            "manifest": "Manifest"
        },
        "parts": {
            "cart": {
                "totalLabel": "Total",
                "subTotalLabel": "Subtotal",
                "taxesLabel": "Taxes",
                "feesLabel": "Fees",
                "bookingFeeLabel": "Booking fee",
                "processingFeeNote": "Card payment will include {{amount}} processing fee.",
                "processingFeeLabel": "Processing Fee",
                "grandTotalLabel": "Grand Total",
                "discountLabel": "Discount",
                "previouslyRefundedLabel": "Previously refunded",
                "refundThisTimeLabel": "Refund this time"
            },
            "footer": {
                "copyright": "© {{year}} {{appName}}. All rights reserved."
            },
            "venue": {
                "addressLabel": "Address",
                "phoneLabel": "Phone",
                "reachUsAt": "You can reach us at:",
                "getDirectionLabel": "Get direction",
                "viewDirections": "View directions and plan your trip"
            }
        },
        "affiliate_invoice_dispatch": {
            "remitTo": "Remit to",
            "billedTo": "Billed to",
            "billingMethod": "Billing method",
            "itemTitle": "Item",
            "bookings": "bookings",
            "customers": "customers",
            "footer": "This invoice email was generated automatically by Fireknife.",
            "columns": {
                "invoice": "Invoice",
                "dateRange": "Date Range",
                "created": "Created",
                "dueDate": "Due Date",
                "total": "Total",
                "id": "ID",
                "contact": "Contact",
                "agent": "Agent",
                "voucher": "Voucher",
                "customers": "Customers",
                "item": "Item",
                "availability": "Availability",
                "ticketAmount": "Ticket Amount",
                "commissionRate": "Commission Rate",
                "commissionAmount": "Commission Amount",
                "amount": "Amount",
                "netAmount": "Net Amount",
                "amountDue": "Amount Due"
            }
        },
        "upgrade_eligible_notify": {
            "title": "Bookings eligible for upgrade",
            "intro": "{{count}} booking(s) across {{timeslotCount}} timeslot(s) are now eligible for an upgrade.",
            "eligibleCount": "{{count}} eligible booking(s)",
            "totalValue": "Total upgrade value: {{amount}}",
            "buttonLabel": "Review upgrades"
        }
    },
    "coupons": {
        "title": "Coupons",
        "model": "Coupon",
        "columns": {
            "code": "Code",
            "discountType": "Discount Type",
            "value": "Value",
            "expirationDate": "Expiration Date",
            "status": "Status",
            "uses": "Uses"
        },
        "discountTypes": {
            "percentage": "Percentage",
            "fixed": "Fixed Amount"
        },
        "statuses": {
            "active": "Active",
            "expired": "Expired",
            "depleted": "Depleted",
            "inactive": "Inactive"
        },
        "generate": "Generate Coupons",
        "export": "Export",
        "quantity": "Quantity",
        "maxUses": "Max Uses",
        "maxUsesHelp": "Leave empty for unlimited uses",
        "minOrderAmount": "Minimum Order Amount",
        "minOrderAmountHelp": "Leave empty for no minimum",
        "unlimited": "Unlimited",
        "useCustomCode": "Use Custom Code",
        "customCode": "Custom Code",
        "customCodeHelp": "Enter your desired coupon code",
        "autoGenerateInfo": "{{count}} unique codes will be automatically generated",
        "discountSettings": "Discount Settings",
        "generationSettings": "Generation Settings",
        "codeSettings": "Code Settings",
        "preview": "Preview",
        "summary": "Summary",
        "summaryCustom": "{{count}} coupon(s) with code: {{code}}",
        "summaryAuto": "{{count}} unique coupon code(s)",
        "summaryPercent": "{{value}}% discount",
        "summaryFixed": "${{value}} discount",
        "notSet": "(not set)",
        "minOrderNote": "Minimum order: ${{amount}}",
        "belowMinimum": "Below minimum",
        "previewOrder": "Order Amount",
        "previewFinal": "Final Price",
        "previewBelowMin": "Below minimum order",
        "previewMinNote": "* Minimum order required: ${{amount}}",
        "enterCode": "Enter coupon code",
        "apply": "Apply",
        "verify": "Verify",
        "applyCoupon": "Apply Coupon Code",
        "discountApplied": "Coupon applied: {{discount}}",
        "remove": "Remove",
        "discount": "Discount",
        "invalid": "Invalid coupon code",
        "expired": "This coupon has expired",
        "depleted": "This coupon is no longer available",
        "alreadyUsed": "You have already used this coupon",
        "minOrderNotMet": "Minimum order amount not met",
        "applied": "Coupon applied!",
        "emailRequired": "Please enter a valid email address before applying a coupon",
        "cannotDeleteUsed": "Cannot delete a coupon that has been used",
        "deleteUsedConfirmation": "This coupon has been used. It will be disabled instead of deleted to preserve usage history. Continue?",
        "fields": {
            "maxUses": "Max Uses",
            "expirationDate": "Expiration Date",
            "isActive": "Active"
        },
        "editModal": {
            "title": "Edit Coupon",
            "maxUsesHelp": "Leave empty for unlimited uses"
        },
        "notifications": {
            "generated": "{{count}} coupon(s) generated successfully",
            "generateError": "Error generating coupons",
            "deleted": "Coupon deleted successfully",
            "deleteError": "Error deleting coupon",
            "updated": "Coupon updated successfully",
            "updateError": "Error updating coupon",
            "codeCopied": "Code copied to clipboard",
            "copyError": "Failed to copy code"
        },
        "validation": {
            "positiveValue": "Value must be positive",
            "percentageMax": "Percentage cannot exceed 100",
            "percentageMin": "Percentage must be at least 1",
            "quantityMin": "Quantity must be at least 1",
            "quantityMax": "Quantity cannot exceed 1000",
            "invalidCode": "Invalid coupon code",
            "inactiveCode": "This coupon is no longer active",
            "expiredCode": "This coupon has expired",
            "depletedCode": "This coupon is no longer available",
            "belowMinimum": "Minimum order amount not met"
        }
    },
    "commissionGroups": {
        "manager": "Affiliates manager",
        "canEditBookings": "Can edit member bookings",
        "canEditBookingsHint": "Edit bookings made by agents in this commission group, not just their own.",
        "managementTitle": "Affiliates management",
        "title": "Commission Groups",
        "model": "Commission group",
        "columns": {
            "name": "Name",
            "commissionMatrix": "Commission Matrix",
            "affiliateContactEmail": "Affiliate Contact Email",
            "billingType": "Billing Type"
        },
        "affiliateContactEmailPlaceholder": "billing@example.com, accounting@example.com",
        "affiliateContactEmailHelp": "You can enter multiple email addresses separated by commas.",
        "dynamicPricing": {
            "label": "Enable dynamic pricing",
            "help": "When on (and the show's dynamic-pricing integration is enabled), agents in this commission group book at dynamic prices. Agents with the bypass capability always book at the original price."
        },
        "assignmentAffiliateCode": {
            "label": "Affiliate code",
            "placeholder": "activityauthority",
            "setCode": "Set affiliate code",
            "dialogTitle": "Affiliate code",
            "help": "Used in the widget URL as ?affiliate=<code>. Bookings made via this link are auto-credited to this user for this show. Leave blank to remove attribution.",
            "invalid": "Letters, numbers, dashes, underscores only (max 64 chars).",
            "bookingLinkLabel": "Booking link",
            "directLinkLabel": "Direct booking link",
            "embedSnippetLabel": "Embed snippet (drop-in HTML for partner sites)",
            "buttonSnippetLabel": "Button snippet (use on existing partner buttons)",
            "copy": "Copy",
            "shortDirectLink": "Link",
            "shortEmbed": "Embed",
            "shortButton": "Button",
            "unsavedHint": "Preview only — save to make these snippets active."
        },
        "members": {
            "title": "Affiliates and agents",
            "description": "Inviting someone creates their account and emails them a welcome - with their booking link when an affiliate code is created. Inviting an existing member resends that welcome.",
            "affiliateCode": "Affiliate code",
            "showBookingLinks": "Show booking links",
            "resendWelcome": "Resend welcome email",
            "inviteHelp": "They will receive a welcome email - with their booking link when an affiliate code is created.",
            "emptyState": "No affiliates yet - invite one to email them their booking link.",
            "inviteWithCode": "Create affiliate code and booking link",
            "rowActions": "Member actions",
            "copyBookingLink": "Copy booking link",
            "copyEmbedCode": "Copy embed code",
            "showSnippets": "Show booking links & embed",
            "hideSnippets": "Hide booking links & embed",
            "copied": "Copied to clipboard",
            "welcomeSentAt": "Welcome sent {{- date}}",
            "inviteAsManager": "Invite as manager",
            "makeManager": "Make manager",
            "revokeManager": "Revoke manager",
            "allowBookingEdits": "Allow booking edits",
            "roleUpdated": "Member role updated",
            "status": {
                "column": "Status",
                "pending": "Pending",
                "active": "Active",
                "pendingTooltip": "Invited - hasn't created their password yet"
            }
        },
        "tabs": {
            "settings": "Settings",
            "affiliates": "Affiliates"
        },
        "partnerCard": {
            "title": "Partner card on file",
            "setupLinkHelp": "Payment setup link (share with the partner to add a card or bank account):",
            "setupButton": "Setup Stripe customer",
            "created": "Stripe customer created"
        },
        "checklists": {
            "ar": {
                "title": "Billing Net (A/R) - the agent collects payment",
                "onHouseOnly": "Limit this group to \"on-house\" payment methods only (the agent collects cash or card from the customer)",
                "markAgentCollected": "Mark those payment methods as \"Agent Collected\" in the table below",
                "invoice": "The invoice will show the total ticket value minus commission (what the agent owes the venue)"
            },
            "ap": {
                "title": "Referral (A/P) - the venue collects payment",
                "venueCollected": "Limit this group to venue-collected payment methods (card or cash handled by the venue)",
                "notAgentCollected": "Do NOT mark payment methods as \"Agent Collected\"",
                "invoice": "The invoice will show the commission amount (what the venue owes the agent)"
            },
            "deposit": {
                "title": "Referral Deposit - Stripe Connect split",
                "createCardMethod": "Create a new \"card\" payment method with Stripe Connect enabled",
                "limitToThatMethod": "Limit this commission group to only use that payment method",
                "platformFee": "The platform fee is set automatically to the total minus commission",
                "connectReceives": "The Connect account receives the commission portion"
            },
            "card": {
                "title": "Card on File - automatic billing",
                "onHouseOnly": "Limit this group to \"on-house\" payment methods (agent collected)",
                "setupCustomer": "Setup a Stripe customer below and share the payment link with the partner",
                "partnerAddsCard": "The partner adds their card or bank account via the payment setup link",
                "autoBill": "Generate invoices and use \"Charge\" to auto-bill the partner",
                "pastEventsLocked": "Agents cannot modify bookings for past events, so invoice integrity is preserved"
            },
            "transfer": {
                "title": "ACH / bank transfer - card on file v2",
                "sameAsCard": "Same setup as \"Card on File\" above",
                "partnerAddsBank": "The partner adds a bank account (ACH) via the payment setup link instead of a card",
                "async": "ACH payments are asynchronous - status updates arrive via Stripe webhook"
            }
        },
        "billingType": {
            "placeholder": "Select billing type",
            "infoAriaLabel": "Billing type explanations",
            "options": {
                "ar": "Billing Net (A/R)",
                "ap": "Referral (A/P)",
                "deposit": "Referral Deposit",
                "card": "Card on file",
                "transfer": "ACH"
            },
            "descriptions": {
                "ar": "The affiliate (agency) collects the money from the guest and settles the invoice with the venue at the end of the month.",
                "ap": "The venue collects the money and pays the commission to the affiliate at the end of the month.",
                "deposit": "The guest pays by credit card, but the transaction is immediately split (via Stripe Connect). The guest sees two separate charges: one for the venue's net price and one for the agency's commission.",
                "card": "For trusted partners, the system saves the card details and automatically charges it based on the issued invoice.",
                "transfer": "Bank-to-bank transfer via Stripe, which saves on credit card transaction fees."
            }
        },
        "newCommissionGroupTitle": "New commission group",
        "matrixType": {
            "percentage": "Percentage (%)",
            "fixed": "Fixed Amount ($)"
        },
        "matrixInfo": "Set the commission for each combination of ticket type and ticket option. Leave empty for no commission.",
        "guestVisibleLockedInfo": "Publicly available (guest-visible) items are always enabled and their checkbox is locked.",
        "sellPermissionsTitle": "Sell Permissions",
        "sellPermissionsInfo": "Choose which ticket type and ticket option combinations this commission group is allowed to sell.",
        "commissionValuesTitle": "Commission Values",
        "commissionValuesInfo": "Set the commission for each combination of ticket type and ticket option. Leave empty for no commission.",
        "allOptions": "All",
        "noTicketTypesOrOptions": "No ticket types or options available for this show.",
        "commissionType": "Type",
        "commissionValue": "Value",
        "assignments": "Commission Group Assignments",
        "assignmentsInfo": "Assign a commission group per show for this user. Only one commission group can be assigned per show.",
        "noAssignment": "None",
        "notifications": {
            "added": "Commission group added successfully.",
            "updated": "Commission group updated successfully.",
            "deleted": "Commission group deleted successfully.",
            "deleteError": "Commission group cannot be deleted.",
            "assigned": "Commission group assigned successfully.",
            "removed": "Commission group assignment removed successfully.",
            "assignError": "Error assigning commission group.",
            "removeError": "Error removing commission group assignment.",
            "agentInvited": "Agent invited successfully.",
            "welcomeResent": "Welcome email resent.",
            "agentInviteError": "Could not invite agent. Check the email and try again.",
            "agentRemoved": "Agent removed from commission group. They keep venue access - contact an admin to remove the user fully.",
            "agentRemoveError": "Error removing agent."
        },
        "management": {
            "members": "Members",
            "bookings": "Bookings",
            "inviteAgent": "Invite Agent",
            "inviteAgentTitle": "Invite Agent",
            "inviteAgentName": "Agent name",
            "inviteAgentEmail": "Agent email address",
            "inviteAgentSubmit": "Invite",
            "noMembers": "No agents in this group yet.",
            "noBookings": "No bookings found for this group.",
            "noGroups": "No commission groups found for this venue.",
            "removeAgent": "Remove agent",
            "selectGroup": "Commission group",
            "memberColumns": {
                "name": "Name",
                "email": "Email",
                "role": "Role",
                "manager": "Manager",
                "agent": "Agent"
            },
            "bookingColumns": {
                "agent": "Agent",
                "booking": "Booking #",
                "contact": "Contact",
                "availability": "Date",
                "customers": "Tickets",
                "lineTotal": "Total",
                "commission": "Commission",
                "status": "Status"
            }
        }
    },
    "integrations": {
        "title": "Integrations",
        "model": "Integration",
        "configuration": "Configuration",
        "dynamicPricing": {
            "apiKey": "API key",
            "enableToGenerate": "Enable and save to generate",
            "description": "Give this API key to Rising Tide. It already knows our endpoints - it uses the key to read future timeslots, availability, and current prices, then pushes new prices back. A manually-set timeslot price always overrides a pushed price for the same combo."
        },
        "columns": {
            "status": "Status",
            "showTitle": "Show title",
            "name": "Name",
            "type": "Integration type",
            "settings": "Settings",
            "accessKey": "Access key",
            "supplierId": "Supplier ID",
            "enabled": "Enabled",
            "affiliateAgent": "Affiliate agent",
            "commissionGroup": "Commission group",
            "noCommissionGroup": "No commission group"
        },
        "newIntegrationName": "New integration",
        "notifications": {
            "added": "Integration added successfully.",
            "updated": "Integration updated successfully.",
            "deleted": "Integration deleted successfully.",
            "deleteError": "Integration cannot be deleted since it has bookings."
        },
        "validation": {
            "affiliateAgentRequired": "Select an affiliate agent for the selected commission group."
        },
        "description": "Connect your {{type}} account using API credentials.",
        "activiter": {
            "widgetUrl": "Widget URL",
            "apiUrl": "API URL",
            "apiKey": "API Key",
            "noApiKey": "Enable integration to generate API key",
            "enableToGenerate": "Enable the integration to generate an API key",
            "description": "The API key is tied to the show's venue and does not expire.",
            "apiKeyRegenerated": "API key regenerated successfully."
        },
        "viatorNetPrices": {
            "title": "Viator Net Prices",
            "info": "Set the net prices for Viator bookings. These prices represent what you receive after Viator's commission. Only ticket combinations with prices in your regular price matrix can be configured.",
            "ticketType": "Ticket Type",
            "originalPrice": "Original price",
            "notAvailable": "Not available - no price set in the regular price matrix",
            "errorLoading": "Error loading ticket data",
            "noTicketsAvailable": "No ticket types or options available for this show"
        },
        "viatorProducts": {
            "title": "Viator Products (manual inventory)",
            "info": "Build your Viator inventory by hand. Each product has a Viator-facing name and one ticket type, and maps each age band to a ticket option with a custom net price. Age bands you leave empty are not offered. When at least one product is configured, it replaces the auto-generated product list sent to Viator.",
            "addProduct": "Add product",
            "productName": "Product name",
            "ticketType": "Ticket type",
            "ageBand": "Age band",
            "option": "Ticket option",
            "price": "Net price",
            "code": "Product code",
            "notOffered": "Not offered",
            "errorLoading": "Error loading ticket data",
            "noTickets": "Create ticket types and options for this show before building Viator products.",
            "codeGeneratedOnSave": "Code generated on save",
            "originalPrice": "Original price",
            "overridden": "overridden"
        }
    },
    "invoices": {
        "title": "Invoices",
        "generateTitle": "Generate Invoice",
        "generateButton": "Generate invoice",
        "historyTitle": "Invoice History",
        "includeDeleted": "Show deleted invoices",
        "selectShow": "Select show",
        "selectCommissionGroup": "Select commission group",
        "selectScopeMessage": "Select a show and commission group to generate an invoice.",
        "selectHistoryScopeMessage": "Select a show and commission group to view invoice history.",
        "deleteConfirm": "Are you sure you want to delete this invoice?",
        "deleteSuccess": "Invoice deleted.",
        "noInvoices": "No invoices found for the selected filters.",
        "active": "Active",
        "deleted": "Deleted",
        "status": "Status",
        "batch": "Batch",
        "sentTo": "Sent To",
        "createdAt": "Created",
        "download": "Download",
        "showOlderBatches": "Show older batches ({{count}})",
        "hideOlderBatches": "Hide older batches",
        "charge": "Charge",
        "chargeTitle": "Charge Invoice",
        "chargeConfirm": "Are you sure you want to charge this invoice to the agency's card on file?",
        "chargeSuccess": "Invoice charged successfully.",
        "invoiceNumber": "Invoice #",
        "day": "Day",
        "addInvoice": "Add invoice",
        "sendEmail": "Send Email",
        "resendEmail": "Resend Email",
        "sendEmailSuccess": "Invoice email sent successfully.",
        "emailSent": "Email sent",
        "tabReceivable": "Receivable",
        "tabPayable": "Payable"
    },
    "reports": {
        "title": "Reports",
        "reportType": "Report Type",
        "salesReport": "Sales Report",
        "transactionsReport": "Transactions Report",
        "manifestReport": "Manifest Report",
        "commissionReport": "Commission Report",
        "bookingFeeReport": "Booking Fee Report",
        "affiliateCancelledRefundedReport": "Affiliate Cancelled/Refunded Report",
        "filters": {
            "show": "Show",
            "allShows": "All Shows",
            "dateFrom": "From",
            "dateTo": "To",
            "showDateFrom": "Show Date From",
            "showDateTo": "Show Date To",
            "bookingDateFrom": "Booking Date From",
            "bookingDateTo": "Booking Date To",
            "bookingStatus": "Booking Status",
            "taxBreakout": "Show Tax Breakout",
            "showTicketTypeBreakdown": "Show ticket type breakdown",
            "showTicketOptionBreakdown": "Show ticket option breakdown",
            "breakdownNoAffiliate": "Break down No affiliate",
            "breakdownNoAffiliateAgents": "Break down agents without a group",
            "hideNoAffiliate": "Hide No affiliate",
            "hideNoGroup": "Hide agents without a commission group",
            "includeAllFields": "Include all fields in export",
            "integrationSource": "Only include integration",
            "none": "None",
            "viator": "Viator",
            "venue": "Venue",
            "agent": "Agent",
            "allAgents": "All Agents",
            "commissionGroup": "Commission Group",
            "allCommissionGroups": "All Commission Groups",
            "day": "Day",
            "clearDates": "Clear all date filters",
            "paymentType": "Payment Type",
            "source": "Source",
            "fareharbor": "FareHarbor"
        },
        "columns": {
            "id": "ID",
            "bookingId": "Booking ID",
            "createdAt": "Created At",
            "contact": "Contact",
            "voucher": "Voucher",
            "customers": "Customers",
            "availability": "Availability",
            "showDate": "Show Date",
            "amountDue": "Amount Due",
            "netAmount": "Net Amount",
            "taxAmount": "Tax Amount",
            "integrationPrice": "Integration Price",
            "processingFee": "Processing Fee",
            "absorbedProcessingFee": "Absorbed Processing Fee",
            "source": "Source",
            "commissionGroup": "Commission Group",
            "bookingStatus": "Booking Status",
            "agent": "Agent",
            "unrealisedBalance": "Balance",
            "unrealisedBalanceTooltip": "Difference between order total and settled payments. Positive = payment still owed. Negative = refund pending.",
            "bookingFees": "Booking fees",
            "refundedFees": "Refunded fees",
            "netFees": "Net fees",
            "show": "Show"
        },
        "summary": {
            "bookings": "{{count}} bookings",
            "customers": "{{count}} customers",
            "total": "Total",
            "groupTotal": "Group Total",
            "grandTotal": "Grand Total"
        },
        "transactions": {
            "totalRecords": "Total Records",
            "finished": "Finished",
            "pending": "Pending",
            "columns": {
                "bookingId": "Booking ID",
                "show": "Show",
                "orderId": "Order ID",
                "orderAmount": "Order Amount",
                "orderStatus": "Order Status",
                "transactionId": "Transaction ID",
                "transactionAmount": "Transaction Amount",
                "transactionStatus": "Transaction Status",
                "paymentType": "Payment Type",
                "transactionDate": "Transaction Date",
                "source": "Source"
            }
        },
        "manifest": {
            "columns": {
                "bookingId": "Booking ID",
                "show": "Show",
                "seats": "Seats",
                "status": "Status",
                "createdAt": "Created at"
            }
        },
        "commission": {
            "agentName": "Agent",
            "bookingId": "Booking",
            "contact": "Contact",
            "showTitle": "Show",
            "availability": "Show Date",
            "customers": "Customers",
            "lineTotal": "Line Total",
            "commissionGroup": "Commission Group",
            "commissionAmount": "Commission"
        },
        "affiliateSalesReport": "Affiliate Sales Report",
        "affiliateSales": {
            "affiliateName": "Affiliate",
            "ticketType": "Ticket Type",
            "ticketOption": "Ticket Option",
            "bookingCount": "Bookings",
            "pax": "Pax",
            "totalSales": "Total Sales",
            "percentageOfTotal": "% of Total",
            "noAffiliateSection": "No affiliate",
            "online": "Online",
            "agentsNoGroup": "Agents (no commission group)"
        },
        "affiliateAgentReport": "Agent Performance Report",
        "affiliateAgent": {
            "agentName": "Agent",
            "commissionGroup": "Commission Group",
            "bookingCount": "Bookings",
            "totalSales": "Total Sales",
            "percentageOfTotal": "% of Total",
            "noGroup": "No group"
        },
        "tableHeader": "{{showTitle}} - {{ticketTypeName}}",
        "noData": "No data available for the selected filters.",
        "totalAmount": "Total Amount",
        "dateRange": "Date Range",
        "export": "Export to Excel",
        "exportSuccess": "Report exported successfully.",
        "loading": "Loading report data...",
        "affiliateInvoiceReport": "Affiliate Invoice Report",
        "affiliateInvoice": {
            "bookingId": "Booking",
            "bookingDate": "Booking Date",
            "contact": "Contact",
            "showTitle": "Show",
            "availability": "Show Date",
            "customers": "Customers",
            "grossAmount": "Gross Amount",
            "commissionAmount": "Commission",
            "netAmount": "Net Amount"
        },
        "affiliateInvoiceDispatchSuccess": "Invoice generation completed: generated {{sent}}, skipped {{skipped}}, failed {{failed}}.",
        "affiliateInvoiceDispatchConfirmTitle": "Active invoices exist",
        "affiliateInvoiceDispatchConfirmMessage": "Active invoice(s) already exist for this period. Do you want to generate new ones anyway?",
        "affiliateCancelledRefunded": {
            "bookingId": "Booking",
            "status": "Status",
            "commissionGroup": "Commission Group",
            "agent": "Agent",
            "ticketType": "Ticket Type",
            "ticketOption": "Ticket Option",
            "cancellationDate": "Cancelled On",
            "cancellationActor": "Cancelled By",
            "cancellationReason": "Reason",
            "originalAmount": "Original Amount",
            "refundedAmount": "Refunded Amount",
            "processingFees": "Processing Fees",
            "grandTotal": "Grand Total"
        },
        "payoutReport": "Payout Report",
        "payout": {
            "line": "Line",
            "amount": "Amount",
            "lines": {
                "totalAmount": "Total amount",
                "processingFees": "Processing fees",
                "bookingFeesTotal": "Booking fees (total)",
                "bookingFeesVenueRebate": "Booking fees - venue rebate",
                "bookingFeesFireknife": "Booking fees - Fireknife",
                "netToVenue": "Net to venue"
            },
            "cols": {
                "bookingId": "Booking",
                "show": "Show",
                "showDate": "Show date",
                "paymentType": "Payment",
                "source": "Source",
                "amount": "Amount",
                "processingFee": "Processing",
                "bookingFee": "Booking fee",
                "venueRebate": "Venue rebate",
                "fireknifeFee": "Fireknife fee"
            },
            "excludedAffiliateLabel": "{{amount}} across {{count}} affiliate bookings is excluded."
        }
    },
    "admin": {
        "seatingGroup": {
            "connectButton": "Connect to group",
            "modalTitleNew": "Connect to seating group",
            "modalTitleExisting": "Seating Group {{n}}",
            "searchPlaceholderLabel": "Search for a booking to connect",
            "searchPlaceholder": "Search by name, email, or confirmation code",
            "createGroup": "Create group",
            "disband": "Disband group",
            "disbandSuccess": "Group disbanded",
            "groupCreated": "Seating group created",
            "membersAdded": "Members added to group",
            "memberRemoved": "Member removed from group",
            "guestNote": "This guest wrote:",
            "badge": "Group {{n}}",
            "currentMembers": "Current members",
            "thisBooking": "This booking",
            "removeMember": "Remove from group",
            "wantsToSitWith": "Wants to sit with",
            "seatGroup": "Seat group",
            "addMembers": "Add to group",
            "noResults": "No other bookings found for this timeslot",
            "unseatGroup": "Clear group seats",
            "nameLabel": "Group name (optional)",
            "namePlaceholder": "e.g. Smith party",
            "saveName": "Save name",
            "nameSaved": "Group name saved"
        }
    }
}
